<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
</div>
</td>

  <td>
    <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
    </div>
  </td>

</tr>
  </thead>
<tbody>
<tr>
  <td class="polish">

<p align="center" style="margin-top:20px;">
    <strong>Umowa zlecenie nr ...</strong>
</p>
<p>
    Zawarta w Łodzi pomiędzy:
</p>
<p><strong>Zleceniodawcą:</strong></p>
<p>
  <strong>Tutore Poland Sp. z o.o.</strong>, z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do
  Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd
  Rejonowy dla Łodzi-Śródmieścia w Łodzi, XX Wydział Krajowego Rejestru Sądowego pod
  nr KRS: 0000670834, NIP: 727-28-12-193, REGON: 366891567, reprezentowaną przez: 
</p>
<p style="margin-top: 55px;">
  <strong>...</strong>,
</p>
<p>a</p>

  <strong>Zleceniobiorcą:</strong>
  <br/>
  Imię i nazwisko: ...
  <br/>
  Pesel: ...
  <br/>
  Adres: ...
  <br/>
  <br/>

  <p align="center" style="margin-top: 10px;"><strong>Warunki umowy</strong></p>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 1 Przedmiot umowy</strong>
</p>
<p style="margin-bottom: 0px;">Zleceniodawca zleca, a Zleceniobiorca podejmuje się wykonywania za wynagrodzeniem na rzecz Zleceniodawcy takich czynności jak:
</p>
<ol>
  <li>rzetelne przygotowanie i prowadzenie zajęć zdalnych dla wszystkich uczestników kursów organizowanych przez Zleceniodawcę zgodnie z programem edukacyjnym szkoły Tutore Poland oraz harmonogramem zajęć. Harmonogram może mieć formę pliku elektronicznego;</li>
  <li>rzetelne prowadzenie dokumentacji potwierdzającej realizację zajęć, zawierającej w szczególności: dzienniki zajęć, listy obecności, dokumentację dotyczącą ewaluacji uczniów, sprawozdania z realizacji zajęć - w formie ustalonej przez Zleceniodawcę;</li>
  <li>terminowe wykonywanie wszystkich wytycznych organizacyjnych Zleceniodawcy w terminach przez niego określonych;</li>
  <li>prowadzenie zajęć odrobieniowych;</li>
  <li>dbanie o należyty stan mienia Zleceniodawcy oraz o porządek i ład w miejscu wykonywania zlecenia;</li>
  <li>współpraca z osobami wyznaczonymi przez Zleceniodawcę, przy czym Zleceniobiorca zobowiązany jest do regularnego i niezwłocznego (najpóźniej na koniec każdego dnia roboczego) odczytywania wiadomości wysyłanych przez te osoby poprzez pocztę e-mail, wiadomości sms lub poprzez komunikatory internetowe i w razie potrzeby jak najszybszego udzielenia odpowiedzi na informacje, w tym szczególnie:
    <ol type="a">
      <li>przekazywanie niezbędnych informacji w zakresie określonym w danej sytuacji,</li>
      <li>udział w zebraniach, rozmowach wizytacyjnych i ewaluacjach;</li>
    </ol>
  </li>
  <li>współpraca z rodzicami uczniów, w tym szczególnie udzielanie niezbędnych informacji dotyczących usługi (np. przekazywanie prac domowych, sprawdzanie i przekazywanie raportów z postępów uczniów);</li>
  <li>inne zadania i projekty zlecone przez Zleceniodawcę.</li>
</ol>
<p>Celem zapewnienia warunków do wykonania niniejszej umowy, Zleceniodawca zobowiązuje się do udostępnienia wszystkich niezbędnych materiałów dydaktycznych, takich jak panele edukacyjne, grafiki do prezentacji oraz indywidualnego konta w systemie do nauki online. Powyższe nie obejmuje sprzętu elektronicznego (komputer, sprzęt nagłaśniający itp.), które Zleceniobiorca zobowiązany jest zorganizować na własny koszt.</p>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 40px;">
  <strong>§ 2 Wykonywanie umowy</strong>
</p>
<ol>
  <li>Zleceniobiorca zobowiązuje się wykonywać przedmiot niniejszej umowy z należytą starannością.</li>
  <li>Wykonanie przedmiotu umowy wskazanego w § 1 odbywać się będzie online za pośrednictwem platform udostępnionych przez Zleceniodawcę.</li>
  <li>Strony ustalają, iż za jednostkę obliczeniową przyjmuje się 60 minut zajęć według ustalonego harmonogramu.</li>
  <li>Łączny wymiar godzin dydaktycznych do wykonania będzie określony w harmonogramie każdorazowo przez Zleceniodawcę z wyprzedzeniem i podsumowany na koniec każdego miesiąca kalendarzowego.</li>
  <li>Strony dopuszczają zmianę dat i godzin zajęć określonych w harmonogramie wyłącznie za obopólną zgodą.</li>
  <li>Zleceniobiorca będzie wykonywać usługi objęte niniejszą umową w warunkach całkowitej niezależności od Zleceniodawcy. W szczególności Zleceniodawca nie będzie uprawniony do wykonywania wobec Zleceniobiorcy jakichkolwiek praw kierowniczych, nie ingerując w organizację i/lub dyscyplinę pracy Zleceniobiorcy. Wszelkie problemy techniczne lub metodologiczne dotyczące całości powierzonych Zleceniobiorcy czynności będą rozwiązywane przez wspólne porozumienie Stron, z poszanowaniem niezależności działalności zawodowej prowadzonej przez Zleceniobiorcę.</li>
  <li>Zleceniobiorca nie może powierzyć wykonania przedmiotu niniejszej umowy osobie trzeciej.</li>
  <li>Zleceniodawca za zgodą zleceniobiorcy dopuszcza możliwość zlecenia zajęć w stacjonarnej jednostce uzgodnionej przez obie strony.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 3 Obowiązek informacyjny</strong>
</p>
  <ol>
    <li>Zleceniodawca zobowiązany jest dostarczać Zleceniobiorcy wszelkich informacji niezbędnych do realizacji przez niego przedmiotu umowy.
</li>
    <li>Zleceniobiorca zobowiązany jest udzielać Zleceniodawcy potrzebnych informacji o przebiegu realizacji przez niego przedmiotu umowy.</li>
  </ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 5px;">
  <strong>§ 4 Absencje i powiadamianie o nich</strong>
</p>
<ol>
  <li>W przypadku niemożności przeprowadzenia zajęć określonych w § 1 w terminach określonych w harmonogramie z przyczyn leżących po stronie Zleceniobiorcy zobowiązuje się on do niezwłocznego powiadomienia Zleceniodawcy o zaistniałym fakcie, nie później niż 7 dni przed planowanymi zajęciami. W takim przypadku Zleceniodawca może wyznaczyć osobę, która zastąpi Zleceniobiorcę w wykonaniu zlecenia opisanego w niniejszej umowie.</li>
  <li>W przypadku nagłej niedyspozycji wynikającej z choroby lub złego stanu zdrowia, które wystąpiło nagle, Zleceniobiorca może nie zachować 7-dniowego okresu powiadomienia o niemożności wykonywania zlecenia. Zleceniobiorca zobowiązuje się niezwłocznie, nie później niż 4 godziny po wystąpieniu zdarzenia, powiadomić o takiej sytuacji Zleceniodawcę.</li>
  <li>W przypadku nagłej niedyspozycji wynikającej z choroby lub złego stanu zdrowia, które wystąpiło nagle, Zleceniobiorca może nie zachować 7-dniowego okresu powiadomienia o niemożności wykonywania zlecenia, jednak zobowiązany jest do poinformowania Zleceniodawcy niezwłocznie po zaistnieniu takiego zdarzenia. Zleceniobiorca potwierdza to, na podstawie e-zwolnienia lekarskiego, które wpłynie na profil Zleceniodawcy w portalu PUE ZUS.</li>
  <li>W przypadku nieprzeprowadzenia zajęć w terminie wynikającym z harmonogramu i nie powiadomienia o tym fakcie Zleceniodawcy z wyprzedzeniem nie mniejszym niż 7 dni przed planowanymi zajęciami, Zleceniodawca może rozwiązać umowę ze skutkiem natychmiastowym bez zachowania okresu wypowiedzenia. W takim przypadku, niezależnie od możliwości wypowiedzenia umowy, Zleceniodawca może ponadto dochodzić kary umownej w wysokości 5 000 zł (słownie: pięć tysięcy złotych) od Zleceniobiorcy za poniesione straty, Zleceniodawca może także dochodzić odszkodowania przenoszącego wartość zastrzeżonej kary umownej. Powyższy zapis nie dotyczy sytuacji losowych uniemożliwiających powiadomienie Zleceniodawcy o niemożliwości przeprowadzenia zajęć.</li>
  <li>W przypadku niemożności przeprowadzenia przez Zleceniobiorcę zajęć zaplanowanych według harmonogramu i niemożliwości znalezienia zastępstwa przez Zleceniodawcę,
     Zleceniobiorca zobowiązany jest do przeprowadzenia zajęć w ilości godzin równej nieodbytym zajęciom tzw. zajęcia odrobieniowe § 1 ust. 4, w innym terminie uzgodnionym pisemnie ze Zleceniodawcą, nie później niż 7 dni od planowanej daty zaplanowanych zajęć.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 5 Czas trwania umowy i okres wypowiedzenia</strong>
</p>
<ol>
  <li>Strony zawierają umowę od dnia ... do dnia 31-08-2023 r.</li>
  <li>Strony mogą rozwiązać umowę z zachowaniem miesięcznego okresu wypowiedzenia, ze skutkiem prawnym na koniec następnego miesiąca kalendarzowego, po pisemnym przesłaniu informacji o wypowiedzeniu umowy (z zastrzeżeniem ust. 3 niniejszego paragrafu).</li>
  <li>Zleceniodawca ma prawo rozwiązać niniejszą umowę bez zachowania okresu wypowiedzenia w sytuacji braku możliwości powierzenia przedmiotu niniejszej umowy lub jeżeli Zleceniobiorca rażąco sprzeciwia się postanowieniom niniejszej umowy, przez co strony rozumieją w szczególności:
    <ol type="a">
      <li>zachowanie Zleceniobiorcy polegające na niewykonywaniu obowiązków określonych w § 1, pomimo uprzedniego wezwania ze strony Zleceniodawcy do zaniechania naruszeń,</li>
      <li>złamanie przez Zleceniobiorcę zakazu konkurencji,</li>
      <li>ujawnienie przez Zleceniobiorcę Informacji Poufnych,</li>
      <li>wszelkie inne naruszenia niniejszej umowy.</li>
    </ol>
  </li>
  <li>W przypadku rozwiązania umowy Zleceniobiorca zobowiązuje się do zwrotu materiałów udostępnionych na czas trwania umowy przez Zleceniodawcę w terminie do 14 dni od dnia rozwiązania lub wygaśnięcia umowy. W przypadku braku zwrotu materiałów w wyznaczonym terminie Zleceniodawca może nałożyć na Zleceniobiorcę karę finansową o wartości otrzymanych materiałów. Dodatkowo Zleceniobiorca może zostać obciążony kosztami przesyłki.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 6 Wynagrodzenie</strong>
  </p>
<ol>
<li>
    Z tytułu prawidłowego wykonania czynności wymienionych w § 1 Zleceniobiorca otrzyma wynagrodzenie w wysokości: ... zł (słownie: ... złotych) brutto za jedną lekcję rozumianą zgodnie z § 2 ust. 3.
</li>
<li>W przypadku przeprowadzenia lekcji pokazowej wynagrodzenie za jedną lekcję pokazową (rozumianą zgodnie z § 2 ust. 3 niniejszej umowy) wynosi ... zł (słownie: ... złotych) brutto.</li>
  <li>Całkowite miesięczne wynagrodzenie będzie wynikać ze stawki godzinowej wynikającej z ust. 1 i 2 niniejszego paragrafu oraz liczby lekcji przeprowadzonych w danym miesiącu, w oparciu o zestawienie i dokumentację, o których mowa w ust. 4 niniejszego paragrafu. W przypadku, gdy jedna lekcja zgodnie z harmonogramem, trwa więcej bądź mniej niż  60 minut to stawka  wynagrodzenia za jedną lekcję będzie proporcjonalnie obniżona bądź powiększona. Zleceniobiorcy nie przysługuje dodatkowe wynagrodzenie za dokonanie czynności dodatkowych związanych z przygotowaniem, organizacją i raportowaniem zajęć.</li>
  <li>Zleceniobiorca jest zobowiązany do przygotowania i przedłożenia Zleceniodawcy w formie elektronicznej:
    <ol type="a">
        <li>
            zestawienia liczby godzin przepracowanych w danym miesiącu, wygenerowanego z narzędzi do ewidencjonowania godzin udostępnionego przez Zleceniodawcę, <u>najpóźniej w pierwszym dniu roboczym następnego miesiąca.</u>
        </li>
        <li>
            prowadzonej dokumentacji potwierdzającej realizację zajęć w danym miesiącu, w szczególności dzienników zajęć i list obecności uczniów, <u>najpóźniej do ostatniego dnia miesiąca, za który Zleceniobiorcy przysługuje wynagrodzenie z tytułu wykonania zlecenia.</u>
        </li>
    </ol>
    Zweryfikowane przez Zleceniodawcę zestawienie i dokumentacja będą stanowić podstawę do wypłaty wynagrodzenia Zleceniobiorcy. 
  </li>
  <li>Zleceniodawca może obniżyć o kwotę do 15% wysokości wynagrodzenia brutto za dany miesiąc, w przypadku niestosowania się do zapisów zawartych w umowie w szczególności: niedotrzymywania podanej dyspozycyjności, spóźniania się na zajęcia, nieodpisywania na e-maile oraz nieodbierania telefonów od osób wskazanych do kontaktu przez Zleceniodawcę, uzasadnionych skarg rodziców na jakość prowadzonych lekcji, niewywiązywania się z obowiązku oceniania dzieci w ramach raportów, nie zachowywania zasad kultury osobistej na zajęciach oraz w kontakcie z osobami wskazanymi przez Zleceniodawcę, niewywiązywania się z wytycznych dotyczących programu i jakości prowadzonych zajęć edukacyjnych określonych przez Zleceniodawcę.</li>
<li>Wynagrodzenie Zleceniobiorcy będzie płatne z dołu w cyklu miesięcznym do 15-tego każdego miesiąca, przelewem na numer konta bankowego wskazanego przez Zleceniobiorcę.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 30px;">
  <strong>§ 7 Premia</strong>
</p>
<ol>
  <li>Zleceniodawca może przyznać Zleceniobiorcy premię uznaniową w wysokości do 15% wynagrodzenia brutto, której przyznanie jest uzależnione od stopnia realizacji przydzielonych zadań indywidualnych. Zadania indywidualne na kolejny miesiąc będą przedstawiane z odpowiednim wyprzedzeniem.</li>
  <li>Dodatkowo Zleceniodawca może przyznać dodatkową premię uznaniową za inne cele niezwiązane z ust. 1 niniejszego paragrafu.</li>
  <li>Premia nie ma charakteru roszczeniowego, zaś jej przyznanie, jak i określenie jej wysokości należy do swobodnego uznania Zleceniodawcy.</li>
  <li>Wyliczenie i wypłata premii następuje w ciągu 15 dni od zakończenia miesięcznego okresu rozliczeniowego.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 50px;">
  <strong>§ 8 Informacje poufne</strong>
</p>
<ol>
  <li>Przez Informacje Poufne strony rozumieją wszelkie informacje przekazane Zleceniobiorcy przez Zleceniodawcę lub uzyskane przez Zleceniobiorcę w inny sposób w związku z wykonywaniem niniejszej umowy, obejmujące informacje techniczne, technologiczne, organizacyjne lub inne informacje posiadające wartość gospodarczą, które dotyczą Zleceniodawcy i jego działalności, a w szczególności materiały dydaktyczne wykorzystywane przez Zleceniodawcę, baza danych kontaktowych do Klientów Zleceniodawcy (w tym także klientów, którzy zakończyli współpracę ze Zleceniodawcą do 12 miesięcy po zakończeniu umowy), systemy komputerowe oraz pozostałe informacje uzyskiwane od Zleceniodawcy w trakcie wykonywania umowy.</li>
  <li>Zleceniobiorca zobowiązuje się, że Informacje Poufne uzyskane w ramach niniejszej umowy będą utrzymywane w tajemnicy przez Zleceniobiorcę i wykorzystywane wyłącznie do wykonania niniejszej umowy. Informacje Poufne nie będą wykorzystywane w innych celach ani nie będą ujawniane, czy udostępniane osobom trzecim, w całości lub w części. Zobowiązanie do zachowania poufności dotyczy Informacji Poufnych uzyskanych przez Zleceniobiorcę od Zleceniodawcy w formie pisemnej oraz ujawnionych Zleceniobiorcy ustnie, wizualnie, elektronicznie lub w inny sposób. Zleceniobiorca zobowiązuje się utrzymywać otrzymane Informacje Poufne w tajemnicy i nie ujawniać ich komukolwiek bez pisemnej zgody Zleceniodawcy.</li>
  <li>Zleceniobiorca, po zakończeniu współpracy Stron, bądź też, przed jej zakończeniem – na każde żądanie Zleceniodawcy - zobowiązany będzie zwrócić Zleceniodawcy w ciągu 3 dni wszelkie Informacje Poufne, wraz z dokumentacją i innymi nośnikami, na których zostały one utrwalone, jak również, kopiami dokumentacji lub nośników zawierających takie Informacje. Zleceniobiorca zobowiązuje się do usunięcia z pamięci komputerów oraz innych urządzeń wszystkich otrzymanych lub wykonanych materiałów w sposób uniemożliwiający ich odtworzenie oraz wykorzystywanie w przyszłości w jakiejkolwiek formie.</li>
  <li>W przypadku naruszenia przez Zleceniobiorcę postanowień ustępów poprzedzających, w szczególności, poprzez niezgodne z tą umową ujawnienie lub udostępnienie materiałów oraz Informacji Poufnych, Zleceniobiorca zobowiązany będzie do zapłaty na rzecz Zleceniodawcy kary umownej w wysokości 5 000,00 zł (słownie: pięć tysięcy złotych) za każde takie naruszenie. Kara taka płatna będzie w terminie 14 dni od daty złożenia przez Zleceniodawcę oświadczenia o obciążeniu Zleceniobiorcy karą umową.</li>
  <li>Jeżeli wysokość szkody lub utraconych korzyści Zleceniodawcy wynikających z naruszenia przez Zleceniobiorcę postanowień niniejszej umowy przewyższać będzie wysokość kary umownej wskazanej w ust. 4 niniejszego paragrafu, Zleceniodawca może dochodzić odszkodowania uzupełniającego na zasadach ogólnych wynikających z Kodeksu cywilnego.</li>
  <li>Za naruszenie zasad opisanych w niniejszej umowie, Zleceniodawca uznaje także każdorazowe wykorzystanie materiałów dydaktycznych Zleceniodawcy do prywatnych celów Zleceniobiorcy oraz do celów nauczania osób, które nie są Klientami Zleceniodawcy.</li>
  <li>Niezależnie od wygaśnięcia czy rozwiązania niniejszej umowy, zobowiązania Zleceniobiorcy zachowania w poufności Informacji Poufnych pozostają w mocy bezterminowo.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
      <strong>§ 9 Zakaz konkurencji</strong>
    </p>
    <ol>
      <li>
        Zleceniobiorca jest zobowiązany do powstrzymania się od podejmowania i wykonywania działalności konkurencyjnej wobec Zleceniodawcy, w czasie obowiązywania niniejszej Umowy - zgodnie z definicją opisaną w niniejszym paragrafie.
        </li>
        <li>
          Postanowienia dotyczące zakazu konkurencji, Strony określają szczegółowo w dalszej części niniejszego paragrafu. 
      </li>
      <li>
        Za działalność konkurencyjną w rozumieniu niniejszego paragrafu Strony uznają oferowanie lub świadczenie przez Zleceniobiorcę, na jakiejkolwiek podstawie lub formie, usług edukacyjnych podobnych do usług oferowanych przez Zleceniodawcę, na rzecz klientów Zleceniodawcy, którzy zawarli ze Zleceniodawcą umowę najpóźniej w dniu wygaśnięcia albo rozwiązania niniejszej umowy.
      </li>
      <li>
        Za działalność konkurencyjną uznaje się również:
        <ol type="a">
          <li>
            świadczenie przez Zleceniobiorcę pracy na rzecz podmiotu prowadzącego działalność konkurencyjną wobec Zleceniodawcy (zgodnie z definicją zawartą w ust. 5 niniejszego paragrafu), w tym świadczenie usług na rzecz takich podmiotów na podstawie jakiejkolwiek innej umowy cywilnoprawnej,
          </li>
          <li>
            prowadzenie przez Zleceniobiorcę działalności konkurencyjnej, zgodnie z definicją opisaną w ust. 3, wobec Zleceniodawcy, także za pośrednictwem osób trzecich,
          </li>
          <li>
            bycie wspólnikiem lub członkiem organów spółki prowadzącej działalność konkurencyjną wobec Zleceniodawcy, zgodnie z definicją opisaną w ust. 5,
          </li>
          <li>
            pełnienie funkcji agenta, pełnomocnika lub prokurenta w podmiotach prowadzących działalność konkurencyjną wobec Zleceniodawcy, zgodnie z definicją opisaną w ust. 5.
          </li>
        </ol>
      </li>
      <li>
        Za podmiot prowadzący działalność konkurencyjną wobec Zleceniodawcy uznaje się każdy podmiot, który prowadzi działalność o tożsamym  charakterze do działalności prowadzonej przez Zleceniodawcę, wykorzystując te same lub podobne technologie, które nie są ogólnodostępne (tj. nie są powszechnie znane), oraz działa w oparciu o zbliżony model biznesowy do modelu Zleceniodawcy. Konkurencyjność tych podmiotów polega na tym, że oferują one usługi lub produkty edukacyjne, które mogą być bezpośrednią alternatywą dla usług oferowanych przez Zleceniodawcę, lub mają na celu pozyskanie tych samych klientów, korzystając z podobnych technologii i struktur organizacyjnych.
      </li>
      <li>
        Zleceniobiorca zobowiązuje się, że po wygaśnięciu albo rozwiązaniu niniejszej umowy nie będzie wykorzystywał materiałów, które zostały udostępnione mu przez Zleceniodawcę w trakcie współpracy.
      </li>
      <li>
        W przypadku, gdy w czasie obowiązywania niniejszej Umowy klient Zleceniodawcy złoży Zleceniobiorcy propozycję współpracy, Zleceniobiorca zobowiązany jest poinformować klienta o obowiązującym go zakazie konkurencji i odmówić podjęcia współpracy. Zleceniobiorca ma również obowiązek niezwłocznie poinformować Zleceniodawcę o zaistniałej sytuacji.
      </li>
      <li>
        Zleceniodawca zastrzega sobie prawo do weryfikacji przestrzegania przez Zleceniobiorcę postanowień niniejszego paragrafu.
      </li>
      <li>
        W przypadku naruszenia zakazu konkurencji, Zleceniobiorca zobowiązany jest do zapłaty Zleceniodawcy kary umownej w wysokości 20 000,00 zł (słownie: dwadzieścia tysięcy złotych) za każdy przypadek naruszenia. Zleceniodawcy przysługuje również prawo do dochodzenia odszkodowania na zasadach ogólnych, w wysokości przewyższającej zapłaconą karę umowną.
      </li>
    </ol>
    <br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 10 Doręczenia i korespondencja, zgoda na wykorzystanie wizerunku, RODO</strong>
</p>
<ol>
  <li>Strony postanawiają, że o ile nie dojdzie do pisemnego powiadomienia o zmianie adresu do korespondencji wszelka korespondencja kierowana na adresy podane w oznaczeniu stron, uważa się za doręczone najpóźniej z datą drugiego awizo.</li>
  <li>Adresy poczty elektronicznej podane są w oznaczeniu stron. Pismo wysłane drogą elektroniczną uważa się za doręczone z chwilą, gdy druga strona miała możliwość zapoznania się z nim.</li>
  <li>Zleceniobiorca wyraża zgodę na wykorzystanie swojego wizerunku, zgodnie z załącznikiem do niniejszej umowy. </li>
  <li>Zleceniobiorca zobowiązany jest do stosowania się do przepisów Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (RODO) oraz Ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (t.j. Dz. U. z 2019 r. poz. 1781 z późn. zm). Zleceniobiorca wyraża zgodę na przetwarzanie jego danych osobowych, zgodnie z klauzulą informacyjną stanowiącą załącznik do niniejszej umowy.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 15px;">
  <strong>§ 11 Spory i sąd właściwy</strong>
</p>
<p>Strony oświadczają, że dołożą wszelkich starań by spory wynikłe z niniejszej umowy rozwiązać polubownie. W przypadku sporów, które nie będą mogły zostać rozwiązane polubownie w ciągu 14 dni od daty otrzymania przez drugą stronę pisemnego wezwania do takiego polubownego rozwiązania, zostaną one poddane pod rozstrzygnięcie sądowi właściwemu ze względu na siedzibę Zleceniodawcy.</p>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 12 Kompletność oraz zmiana umowy</strong>
</p>
<ol>
  <li>Niniejsza umowa rozwiązuje i zastępuje wszelkie inne dotychczasowe pisemne lub ustne ustalenia, porozumienia, uzgodnienia i umowy Stron w zakresie objętym jej treścią, które niniejszym tracą moc prawną.</li>
  <li>Strony oświadczają, że poza niniejszą umową nie istnieją między nimi żadne dodatkowe ustalenia czy porozumienia dotyczące przedmiotu niniejszej umowy.</li>
  <li>Wszelkie zmiany niniejszej umowy wymagają formy pisemnej pod rygorem nieważności.</li>
  <li>Rozwiązanie niniejszej umowy wymaga formy pisemnej pod rygorem nieważności.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§ 13 Klauzula salwatoryjna</strong>
</p>
<p style="margin-bottom: 0px;">
Jeżeli którekolwiek z postanowień niniejszej umowy okaże się nieważne w całości lub w części, pozostałe postanowienia pozostają w mocy, Strony zaś zobowiązują się na wniosek którejkolwiek z nich do zastąpienia nieważnych postanowień postanowieniami, których moc prawna i skutek ekonomiczny są najbardziej zbliżone do postanowień zastępowanych.</p>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 14 Prawo właściwe</strong>
</p>
<ol>
  <li>Niniejsza umowa podlega prawu polskiemu.
</li>
  <li>W sprawach nieuregulowanych niniejszą umową zastosowanie mają właściwe przepisy prawa, w szczególności przepisy Kodeksu cywilnego.
  </li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§ 15 Liczba egzemplarzy umowy</strong>
</p>
<p>Niniejsza umowa została sporządzona w dwóch jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.
  <br>
</p>
<br>

 <div>
  <p class="underline">Załączniki stanowiące integralną część umowy:</p>
  <ol>
    <li class="underline">Zgoda na wykorzystanie wizerunku</li>
    <li class="underline">Klauzula informacyjna RODO</li>
    <li class="underline">Upoważnienie do przetwarzania danych osobowych</li>
    <li class="underline">Informacja o monitoringu zajęć on - line</li>
    <li class="underline">Oświadczenie Zleceniobiorcy</li>
    <li class="underline">Ogólne zasady bhp przy pracy administracyjno-biurowej</li>
  </ol>
</div>

<div class="cointainer" style="margin-top: 30px;">
    <div class="left-cointainer">
        <span style="margin-left: 0%;">...</span><br>
        <span style="margin-left: 0%;">(Podpis Zleceniodawcy)</span>
    </div>
    <div class="right-cointainer">
        ...<br>
        <span style="margin-left: 0%;">(Podpis Zleceniobiorcy)</span>
    </div>
</div>
<br>

 <div style="margin-top:5px;page-break-before: always;">
   <p><strong>Załącznik nr 1. ZGODA NA WYKORZYSTANIE WIZERUNKU</strong></p>
   <p>Niniejszym oświadczam, że udzielam Tutore Poland Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440, KRS 0000670834, NIP: 727-28-12-193, REGON: 366891567, (dalej: Tutore Poland Sp. z o.o.) zgody, na nieodpłatne utrwalenie oraz nieograniczone czasowo i terytorialnie wielokrotne wykorzystanie i rozpowszechnianie mojego wizerunku w formie fotografii w związku z wykonywaniem umowy zlecenia w celu umieszczenia jej w firmowej stopce mailowej. Wizerunek będzie wykorzystywany wyłącznie na czas trwania umowy w formie zdjęcia w korespondencji mailowej wysyłanego w imieniu Zleceniodawcy.</p>
   <p>Jak również niniejszym oświadczam, że udzielam Tutore Poland Sp. z o.o. zgody, na nieodpłatne utrwalenie oraz nieograniczone czasowo i terytorialnie wielokrotne wykorzystanie i rozpowszechnianie mojego głosu lub wypowiedzi utrwalonych w trakcie wykonywania niniejszej umowy o świadczenie usług przy użyciu telefonów o połączeniu VoIP (Voice over Internet Protocol).</p>
   <p>Niniejsza  zgoda  obejmuje  następujące  pola  eksploatacji:  wykorzystanie,  utrwalanie, obróbkę  i  powielanie  wykonanych  zdjęć/nagrań,  obrót  egzemplarzami,  na  których  utrwalono mój wizerunek lub głos oraz na zwielokrotnianie wizerunku/głosu wszelkimi dostępnymi technikami i metodami, rozpowszechnianie   oraz   publikowanie,   w   materiałach służących   działalności Tutore Poland w szczególności w materiałach szkoleniowych, edukacyjnych i promocyjnych w dowolnej formie.</p>
   <p>Tutore Poland Sp. z o.o. przysługuje wyłączne prawo decydowania o formie i czasie wykorzystywania mojego wizerunku, głosu, wypowiedzi w całości lub w postaci dowolnych fragmentów. Wizerunek może być użyty do różnego rodzaju form elektronicznego przetwarzania obrazu, kadrowania i kompozycji, bez obowiązku akceptacji produktu końcowego, lecz nie w formach obraźliwych lub ogólnie uznanych za nieetyczne.</p>
   <div style="page-break-before: always;">
  <p><strong>Załącznik nr 2. KLAUZULA INFORMACYJNA</strong></p>
  <p>Klauzule informacyjne z art. 13 RODO</p>
  <p> Zgodnie z art. 13 ust. 1 i 2 rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych) (Dz. Urz. UE L 119 z 04.05.2016, str. 1), dalej „RODO”, informuję, że:</p>
  <p style="margin-bottom: 10px;">Administratorem Pani/Pana danych osobowych jest Tutore Poland Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440, KRS 0000670834, zwany dalej: „ADO”.</p>
  <p style="margin-bottom: 10px;">Może Pan/Pani kontaktować się z ADO pisząc na adres: Tutore Poland Sp. z o.o, ul. Piotrkowska 157A, 90-440, mail kadry@tutore.eu oraz poprzez kontakt z Inspektorem Ochrony Danych na adres e-mail: mlokaj@mlkancelaria.com</p>
  <p>ADO przetwarza dane osobowe w celu:</p>
  <ol type="a">
    <li>nawiązania współpracy - Art. 6 ust. 1 lit. b, f RODO,</li>
    <li>zapewnienia kontaktu pomiędzy Stronami (adres  e – mail, nr telefonu) - Art. 6 ust. 1 lit. b, f RODO,</li>
    <li>realizacji praw i obowiązków wynikających z umowy o świadczenie usług - Art. 6 ust. 1 lit. b, c, f RODO,</li>
    <li>prowadzenia rejestru korespondencji - Art. 6 ust. 1 lit. c, f RODO,</li>
    <li>ewidencji przebiegu współpracy (w tym realizacja płatności) - Art. 6 ust. 1 lit. b, c RODO,</li>
    <li>dochodzenia roszczeń i praw - Art. 6 ust. 1 lit. b, f RODO,</li>
    <li>realizacji obowiązków podatkowych - Art. 6 ust. 1 lit. b, c RODO,</li>
  </ol>
  <br>
  <p style="margin-bottom: 10px;">Odbiorcami danych osobowych są podmioty, którym ADO powierzył przetwarzanie danych osobowych, w szczególności: dostawcy usług technicznych i organizacyjnych, dostawcy usług księgowych, kadrowych, prawnych i doradczych, banki (realizacja płatności), organy publiczne w ramach realizacji obowiązków związanych z prowadzeniem działalności gospodarczej przez ADO. </p>
  <p style="margin-bottom: 10px;">ADO nie przekazuje danych osobowych poza Europejski Obszar Gospodarczy.</p>
  <p style="margin-bottom: 10px;">Dane osobowe przechowywane będą przez okres realizacji umowy, a następnie przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa, w tym w szczególności: dochodzenie roszczeń (okres przedawnienia roszczeń), prowadzenie ksiąg rachunkowych i dokumentacji podatkowej (5 lat od końca roku kalendarzowego, w którym powstał obowiązek podatkowy).</p>
  <p style="margin-bottom: 10px;">Osoba, której dane są przetwarzane ma prawo dostępu do swoich danych oraz otrzymania ich kopii, prawo do sprostowania (poprawiania) swoich danych, prawo do usunięcia danych, prawo do cofnięcia zgody, prawo do ograniczenia przetwarzania, prawo do bycia zapomnianym, prawo do sprzeciwu, prawo do przenoszenia danych, prawo do wniesienia skargi do Urzędu Ochrony Danych Osobowych.</p>
  <p style="margin-bottom: 10px;">Podanie przez Panią/Pana danych osobowych oraz zgoda na ich przetwarzanie i rozpowszechnianie wizerunku jest dobrowolne, ale stanowi warunek konieczny dla nawiązania współpracy i ewentualnego zawarcia umowy w formie pisemnej oraz realizacji praw i obowiązków przez ADO.</p>
  <p style="margin-bottom: 10px;">W ramach działalności ADO nie dochodzi do zautomatyzowanego podejmowania decyzji, w tym profilowania, z wykorzystaniem zebranych danych osobowych.</p>
  <p style="margin-bottom: 10px;">Zakres danych podlegający przetwarzaniu: imię i nazwisko, adres mailowy, numer telefonu, wizerunek, PESEL.</p>
  <p style="margin-bottom: 10px;">...</p>
  <p style="margin-bottom: 10px;">Podpis</p>
  </div>
  </div>

<div style="page-break-before: always;">
  <div class="cointainer" style="margin-top: 60px;">
    <div class="left-cointainer">
      <p><em>Załącznik nr 3</em></p>
    </div>
    <div class="right-cointainer">
      <p style="margin-bottom: 10px; font-size: 14px;">
    Łódź, dnia {{ aktualnaData() }} r.
      </p>
    </div>
</div>
  
  
<p align="center" class="subheading" style="margin-bottom: 10px;">
  <strong>
    Upoważnienie uzupełniające<br>
    do przetwarzania danych osobowych w zbiorze w wersji<br>
    papierowej i elektronicznej
  </strong>
</p>
<p class="p-margin">
  Na podstawie art. 29 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO, niniejszym:
</p>
<p class="p-margin">
  z dniem podpisania upoważnienia przez obie strony
</p>
<p class="p-margin">
  upoważniam Pana/Panią ... Zleceniobiorcę Tutore Poland Sp. z o.o.
</p>
<p class="p-margin">
  realizująca umowę zlecenie poprzez prowadzenie zajęć z przedmiotu ... w dziale edukacji
</p>
<p class="p-margin">
  do przetwarzania danych osobowych zawartych w poniżej wymienionych zbiorach danych osobowych:
</p>
  <ol type="a">
    <li>w wersji elektronicznej:
      <ul>
        <li>
          zbiór danych osobowych Klientów: rodziców (opiekunów prawnych) dzieci, młodzieży i dorosłych korzystających z usług oferowanych przez Tutore Poland – imię i nazwisko, adres zamieszkania, telefon kontaktowy, adres e-mail,
        </li>
        <li>
          zbiór danych osobowych Klientów: dzieci, młodzieży i dorosłych korzystających z usług oferowanych przez Tutore Poland– imię i nazwisko, adres zamieszkania, telefon kontaktowy, adres e-mail.
        </li>
      </ul>
    </li>
  </ol>
<p class="p-margin">
  w zakresie wglądu, wprowadzania, modyfikacji, usuwania i archiwizacji danych osobowych objętych wyżej wymienionymi zbiorami.
</p>
<p class="p-margin">
  Niniejsze  upoważnienie  nie  upoważnia  do  udzielania  dalszych  upoważnień  i  wygasa  z  dniem ustania umowy zlecenia, a ponadto może być w każdym czasie zmienione lub odwołane.
</p>
<p>
  Zobowiązuję Pana/Panią do przetwarzania danych osobowych  zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy - Administratora Danych Osobowych. Zobowiązuję Pana/Panią do przetwarzania danych osobowych  zgodnie z udzielonym upoważnieniem, rozporządzeniem Parlamentu Europejskiego i Rady  (UE)2016/679 z 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych  oraz uchylenia dyrektywy 95/46/WE ( Dz. Urz. UE L 119, s.1) oraz przepisami ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (Dz.U. z 2018 r. poz.1000) i obowiązującymi w Tutore Poland Sp. z o.o..wewnętrznymi regulacjami w sprawie ochrony danych osobowych.
  <br>
  Naruszenie ww. obowiązków  może skutkować  poniesieniem  odpowiedzialności karnej oraz stanowi podstawę do rozwiązania umowy zlecenie.
</p>

<div class="container" style="page-break-before: always;">
    <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
      <tr>
        <td id="oswiadczenie">
          <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
          <ol>
        <li>Ja niżej podpisany/a oświadczam, iż:
        <ol type="a">
          <li>
            zapoznałem/am się z treścią i zakresem upoważnienia i przyjmuję je do wiadomości,
          </li>
          <li>
            treść upoważnienia jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący,
          </li>
          <li>
            zobowiązuję się do przetwarzania danych osobowych  zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy,
          </li>
          <li>
            zobowiązuję się do przetwarzania danych osobowych  zgodnie z udzielonym upoważnieniem, przepisami Rodo oraz wewnętrznymi procedurami obowiązującymi u Zleceniodawcy, w tym Polityką Prywatności,
          </li>
          <li>
            zobowiązuję się do zachowania w tajemnicy danych osobowych, do których mam lub będę miał dostęp w związku z wykonywaniem obowiązków na rzecz Tutore Poland Sp. z o.o. oraz zachowania w tajemnicy sposobów zabezpieczenia danych osobowych, również po odwołaniu lub zmianie upoważnienia, a także po zakończeniu trwania umowy zlecenie.
          </li>
        </ol>
        </li>
        </ol>
          <div class="right-cointainer" style="float: right; margin-top: 20px;">
        <span style="font-size: 14px;">...</span>
        <br>
        <span>czytelny podpis Zleceniobiorcy</span>
        </div>
      </td>
    </tr>
  </table>
  </div>

<p class="subheading p-margin" style="text-align: center;">
  ...
  <br>
  <strong>w imieniu Administratora</strong>
</p>
<br>
<p>Niniejsze upoważnienie uchylone zostało w dniu rozwiązania umowy zlecenie.</p>
</div>

<div style="page-break-before: always;">
  <p><em>Załącznik nr 4</em></p>
  <p class="subheading" style="margin-bottom: 0px;"><strong>Informacja o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on - line</strong></p>
  <br>
  Informujemy, iż Tutore Poland Sp. z o.o. korzysta z środków technicznych umożliwiających monitoring prowadzonych zajęć on – line oraz nagrywania szkoleń wewnętrznych on - line. Monitoringiem są objęte urządzenia rejestrujące obraz oraz dźwięk, z których korzysta użytkownik w celu realizacji zajęć online tj. platforma Clickmeeting bądź aplikacja Zoom, a w przypadku szkoleń wewnętrznych online aplikacja Zoom. Tutore Poland Sp. z o.o. stosuje monitoring w następujących celach: zapewnienia najwyższych standardów obsługi zajęć lekcyjnych realizowanych przez pracowników/zleceniobiorców, prawidłowości wykonywania powierzonych czynności oraz ewentualnego poprawienia jakości lekcji, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy), a w przypadku szkoleń wewnętrznych on – line w celu zapewnienia możliwości udostępnienia nagrań nowym pracownikom/zleceniobiorcom. Informujemy, iż: system monitoringu audiowizualnego i dźwiękowego zajęć online składa się z systemu rejestrującego platformy Clickmeeting bądź Zoom oraz serwera, na którym są zapisywane zajęcia online, dostęp do zapisu nagrań zajęć online posiadają osoby upoważnione przez Zarząd Tutore Poland Sp. z o.o. tj. Manager Działu Call Center, Dyrektor ds. Zarządzania Procesami, Teamleader Działu Infolinii, osoby, które mają wgląd do zarejestrowanego obrazu mają świadomość odpowiedzialności za ochronę danych osobowych oraz posiadają stosowne upoważnienie wydane przez Administratora danych osobowych. W toku nagrania dochodzi do przetwarzania danych osobowych w postaci głosu, wizerunku oraz imienia i nazwiska pracownika/zleceniobiorcy prowadzącego zajęcia lub szkolenie. Administratorem danych osobowych uzyskanych w ramach monitoringu zajęć on – line i w toku nagrywania szkoleń wewnętrznych on - line jest Tutore Poland Sp. z o.o., który w związku z opisaną powyżej czynnością zamieszcza poniżej wymaganą klauzulę informacyjną dotyczącą przetwarzania danych osobowych.
</div>

<div style="margin-top: 40px; font-size: 10px;">
  <p align="right" style="font-size: 14px; margin-bottom: 0;">
        Łódź, dnia {{ aktualnaData() }} r.
      </p>
        <p style="font-size: 14px; margin-bottom: 0;">...</p>
        <p style="font-size: 14px;">Imię i nazwisko Zleceniobiorcy</p>
<p align="center" class="subheading" style="margin-top: 100px;">
  <strong>INFORMACJA O PRZETWARZANIU DANYCH OSOBOWYCH</strong>
</p>
<ol>
  <li>
    Informuję, że Administratorem danych osobowych Pani/Pana jako Zleceniobiorcy jest Tutore Poland Sp. z o.o. z siedzibą przy ul. Piotrkowska 157A, 90-440 Łódź, KRS: 0000670834, NIP: 7272812193, tel. 500 965 135, info@tutore.eu
  </li>
  <li>
    Przedstawiając Pani/Panu niniejszą informację o przetwarzaniu danych osobowych Administrator spełnia obowiązek prawny wynikający z art. 15 ust. 1 Rozporządzenia Parlamentu Europejskiego i  Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w  związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO.
  </li>
  <li>
    Administrator pozyskuje informacje o Pani/Panu w związku z obowiązkiem ustawowym, co jest niezbędne do skutecznej realizacji procesu współpracy. W zakresie danych osobowych nie dotkniętych ustawowym warunkiem niezbędności – ich podanie jest dobrowolne.
  </li>
  <li>
    Pani/Pana dane osobowe przetwarzane są w następujących celach, na następującej podstawie i w następującym okresie:
    <ol type="a">
      <li>
        zawarcia oraz realizacji umowy cywilnoprawnej – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. b, c, f RODO) – przez okres współpracy,
      </li>
      <li>
        wyliczenia i wypłaty wynagrodzenia – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit. b RODO) – przez okres współpracy,
      </li>
      <li>
        potrąceń z wynagrodzenia – w celu realizacji obowiązków w zakresie egzekucji z wynagrodzenia wynikających z kodeksu postępowania cywilnego, ustawy o postępowaniu egzekucyjnym w administracji, ustawy o komornikach sądowych (art. 6 ust. 1 lit. c RODO) – przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa,
      </li>
      <li>
        realizacji obowiązków podatkowych – w celu realizacji obowiązków płatnika podatku dochodowego wynikających z ordynacji podatkowej, ustawy o podatku dochodowym od osób fizycznych i innych przepisów podatkowych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku kalendarzowego,
      </li>
      <li>
        realizacji obowiązków wobec ZUS – w celu realizacji obowiązków płatnika  składek  na  ubezpieczenie społeczne  i  zdrowotne wynikających z ustawy o emeryturach i rentach z Funduszu Ubezpieczeń Społecznych, ustawy o systemie ubezpieczeń społecznych oraz ustawy o świadczeniach opieki zdrowotnej finansowanych ze środków publicznych (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit b RODO) – przez okres 5 lat od końca roku kalendarzowego,
      </li>
      <li>
        realizacji obowiązków księgowych – w celu realizacji obowiązków wynikających z ustawy o rachunkowości, ordynacji podatkowej oraz ustawy o podatku dochodowym od osób prawnych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku rozliczeniowego, w którym nastąpiło zdarzenie,
      </li>
      <li>
        bezpieczeństwa fizycznego budynków, pomieszczeń oraz mienia Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) – przez okres współpracy,
      </li>
      <li>
        zapewnienia najwyższych standardów obsługi zajęć lekcyjnych realizowanych przez Współpracowników za pośrednictwem platformy ClickMeeting lub Zoom, prawidłowości wykonywania powierzonych czynności oraz ewentualnego poprawienia jakości lekcji, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy) poprzez monitoring i nagrywanie kursów online – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) – Wizerunek i głos Współpracownika będzie przetwarzany przez okres 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych zajęć stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu,
      </li>
      <li>
        zapewnienia możliwości udostępnienia nagrań nowym Pracownikom i Współpracownikom nagrywanie szkoleń online prowadzonych za pomocą platformy Zoom – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) - Wizerunek i głos Współpracownika będą przetwarzane do czasu wycofania zgody. W razie wycofania zgody nagrania zawierające dane osobowe, podlegają zniszczeniu,
      </li>
      <li>
        zapewnienia najwyższych standardów jakości obsługi klienta, w celu szkoleniowym – umożliwiającym poprawienie jakości obsługi, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy), zapewnienia bezpieczeństwa Współpracownikom w przypadku zdarzeń niepożądanych i niebezpiecznych ze strony Klientów (np. groźby karalne) poprzez monitoring rozmów telefonicznych z Klientami Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) - przez okres do 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych rozmów telefonicznych stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu,
      </li>
      <li>
        tworzenia fotorelacji z obozów dla dzieci i młodzieży na pendrive dla Klientów, fanpagu facebook i Witrynie internetowej www.musicandmore.pl – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) - Wizerunek i głos Współpracownika będą przetwarzane do czasu wycofania zgody. W razie wycofania zgody nagrania zawierające dane osobowe, podlegają zniszczeniu,
      </li>
      <li>
        dochodzenia roszczeń lub obrony przed roszczeniami – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) polegającego na występowaniu w sprawach sądowych – w przypadku toczącego się postępowania przez okres trwania postępowania do czasu jego prawomocnego zakończenia oraz przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa.
      </li>
    </ol>
  </li>
  <li>
    Odbiorcami Pani/Pana danych osobowych będą:
    <ul>
      <li>
        organy administracji publicznej (np. Zakład Ubezpieczeń Społecznych, Urzędy Skarbowe) – na mocy odpowiednich przepisów prawa;
      </li>
      <li>
        zakłady opieki zdrowotnej w celach związanych z medycyną pracy;
      </li>
      <li>
        podmioty zewnętrzne dostarczające i wspierające systemy teleinformatyczne Zleceniodawcy (zarówno ogólną infrastrukturę teleinformatyczną, pocztę elektroniczną, jak i  systemy informatyczne stosowane przez Zleceniodawcę w celu obsługi kadrowo-finansowej lub obiegu dokumentów związanych z zatrudnieniem) – na mocy stosownych umów powierzenia przetwarzania danych osobowych oraz przy zapewnieniu stosowania przez ww. podmioty adekwatnych środków technicznych i organizacyjnych zapewniających ochronę danych,
      </li>
      <li>
        biura księgowe:
      </li>
      <li>
        banki – w celu wypłaty wynagrodzeń i innych świadczeń pieniężnych na rzecz Zleceniodawcy w przypadku ich wypłaty za zgodą Zleceniobiorcy na rachunek bankowy;
      </li>
      <li>
        kontrahenci – w celu umożliwienia kontrahentom (potencjalnym oraz obecnym) kontaktu lub w celu bieżącej realizacji zawartych umów, a związanych z  zajmowanym przez Zleceniobiorcę stanowiskiem pracy; 
      </li>
      <li>
        współpracownicy Zleceniodawcy, którzy świadczą usługi na rzecz Tutore Poland Sp. z o.o., w celu umożliwienia współpracownikom kontaktu ze Zleceniobiorcą,
      </li>
      <li>
        podmioty świadczące dodatkowe usługi dla Zleceniobiorców, wyłącznie w przypadku korzystania przez Zleceniobiorcę z tych usług.
      </li>
      <li>
        instytucje ubezpieczeniowe
      </li>
      <li>
        organizacje administracji zagranicznej w krajach UE, w których realizowana jest umowa (dotyczy realizacji umowy za granicą)
      </li>
      <li>
        podmioty szkoleniowe i realizujące obowiązki BHP (jeśli nie ma komórki BHP u Zleceniodawcy)
      </li>
    </ul>
  </li>
  <li>
    Ma Pani/Pan prawo do:
    <ol type="a">
      <li>
        <strong>dostępu do danych</strong> — uzyskania od Administratora potwierdzenia, czy przetwarzane są Pani/Pana dane osobowe. Jeżeli dane są przetwarzane, jest Pani/Pan uprawniona/y do uzyskania dostępu do nich (art. 15 RODO);
      </li>
      <li>
        <strong>otrzymania kopii danych</strong> — uzyskania kopii danych podlegających przetwarzaniu, przy czym pierwsza kopia jest bezpłatna, a za kolejne kopie właściwy Administrator może nałożyć opłatę w rozsądnej wysokości, wynikającą z kosztów administracyjnych (art. 15 ust. 3 RODO);
      </li>
      <li>
        <strong>sprostowania</strong> — żądania sprostowania danych osobowych, które są nieprawidłowe, lub uzupełnienia niekompletnych danych (art. 16 RODO);
      </li>
      <li>
        <strong>usunięcia danych</strong> — żądania usunięcia danych osobowych, jeżeli Administrator nie ma już podstawy prawnej do ich przetwarzania lub dane nie są już niezbędne do celów przetwarzania (art. 17 RODO);
      </li>
      <li>
        <strong>ograniczenia przetwarzania</strong> — żądania ograniczenia przetwarzania danych osobowych (art. 18 RODO), gdy:
        <ol type="i">
          <li>
            kwestionuje Pani/Pan prawidłowość danych osobowych — na okres pozwalający Administratorowi sprawdzić prawidłowość tych danych,
          </li>
          <li>
            przetwarzanie jest niezgodne z prawem, a sprzeciwia się Pani/Pan ich usunięciu, żądając ograniczenia ich wykorzystywania,
          </li>
          <li>
            Administrator nie potrzebuje już tych danych, ale są one Pani/Panu do ustalenia, dochodzenia lub obrony roszczeń;
          </li>
          <li>
            wniosła Pani/wniósł Pan sprzeciw wobec przetwarzania — do czasu stwierdzenia, czy prawnie uzasadnione podstawy po stronie Administratora są nadrzędne wobec podstaw Pani/Pana sprzeciwu;
          </li>
        </ol>
      </li>
      <li>
        <strong>przenoszenia danych</strong> — otrzymania w ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego danych osobowych Pani/Pana dotyczących dostarczonych Administratorowi, oraz żądania przesłania tych danych innemu Administratorowi, jeżeli dane są przetwarzane na podstawie Pani/Pana zgody, lub umowy z Panią/Panem zawartej oraz jeżeli dane są przetwarzane w sposób zautomatyzowany (art. 20 RODO);
      </li>
      <li>
        <strong>sprzeciwu</strong> — wniesienia sprzeciwu wobec przetwarzania danych osobowych w prawnie uzasadnionych celach Administratora, z przyczyn związanych z Pani/Pana szczególną sytuacją, w tym wobec profilowania. Administrator dokonuje oceny istnienia ważnych prawnie uzasadnionych podstaw do przetwarzania, nadrzędnych wobec Pani/Pana interesów, praw i wolności lub podstaw do ustalenia, dochodzenia lub obrony roszczeń. Jeżeli zgodnie z oceną Pani/Pana interesy będą ważniejsze od interesów Administratora, Administrator będzie zobowiązany zaprzestać przetwarzania danych w tych celach (art. 21 RODO);
      </li>
      <li>
        <strong>prawo wniesienia skargi do organu nadzorczego</strong> – Prezesa Urzędu Ochrony Danych Osobowych, gdy uzna Pani/Pan, iż przetwarzanie danych osobowych Pani/Pana dotyczących narusza przepisy. Skargi można składać w formie:
        <ul>
          <li>
            pisemnej na adres: ul. Stawki 2, 00-193 Warszawa,
          </li>
          <li>
            elektronicznie za pośrednictwem platformy ePUAP.
          </li>
        </ul>
      </li>
    </ol>
  </li>
  <li>
    W trakcie przetwarzania danych osobowych nie dochodzi do wyłącznie zautomatyzowanego podejmowania decyzji ani do profilowania, o których mowa w art. 22 ust. 1 i 4 RODO, co oznacza, że żadne decyzje Pani/Pana dotyczące nie będą zapadać automatycznie oraz że nie będą tworzone żadne profile Pani/Pana dotyczące.
  </li>
  <li>
    Ma Pani/Pan obowiązek informowania Zleceniodawcy o wszelkich zmianach dotyczących Pani/Pana danych osobowych, przekazanych Zleceniodawcy zgodnie z Umową.
  </li>
</ol>
</div>

<div style="page-break-before: always;">
  <div class="container">
    <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
      <tr>
        <td id="oswiadczenie">
          <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
          <ol>
        <li>Ja niżej podpisany/a oświadczam, iż:
        <ol type="a">
          <li>zapoznałem/am się z Informacją o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on - line oraz Klauzulą informacyjną i przyjmuję ją do wiadomości,</li>
          <li>treść Informacji i Klauzuli jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący.</li>
          </ol>
          </li>
          <li>W sposób całkowicie dobrowolny, wyrażam zgodę na przetwarzanie moich danych osobowych w celach wskazanych w Informacji o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on – line.</li>
          <li>Zostałem/am poinformowany/a, że moje dane osobowe przetwarzane są na podstawie wyrażonej przeze mnie dobrowolnej zgody oraz, że przysługuje mi prawo do jej cofnięcia w każdym czasie, przy czym cofnięcie zgody wywołuje skutki prawne od momentu jego złożenia i będzie pozostawało bez wpływu na przetwarzanie moich danych osobowych dla celów związanych z realizacją badania przed złożeniem oświadczenia o cofnięciu zgody.</li>
          <li>W trybie art. 81 ust.1 ustawy o prawie autorskim i prawach pokrewnych wyrażam zgodę na rozpowszechnianie mojego wizerunku przez Tutore Poland Sp. z o.o. w celach wskazanych w Informacji o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on – line.</li>
          </ol>
          <div style="float: right; margin-top: 20px;">
        <span style="font-size: 14px;">...</span>
        <br>
        <span>czytelny podpis Zleceniobiorcy</span>
        </div>
      </td>
    </tr>
  </table>
  </div>
  </div>
</td>

<td class="english">
  <p align="center" style="margin-top: 17px;">
    <strong>Mandate contract nr ...</strong>
</p>
<p>
    Concluded in Łódź between:
</p>
<p><strong>the Mandator:</strong></p>
<p>
  <strong>Tutore Poland Sp. z o.o.</strong>, with its registered office in Łódź at ul. Piotrkowska 157A, postal code: 90-440 Łódź, entered in the Register of Entrepreneurs of the National Court Register, maintained by District Court for Łódź Śródmieście in Łódź, XX Commercial Division of the National Court Register under no. KRS (National Court Register) 0000670834, no. NIP (Tax Identification Number) 727-28-12-193, no. REGON 366891567 (Statistical Identification Number), represented by:
</p>
<p>
  <strong>...</strong>,
</p>
<p>and</p>

  <strong>the Contractor:</strong>
  <br/>
  Name and surname: ...
  <br/>
  no. PESEL: ...
  <br/>
  Address: ...
  <br/>
  <br/>

  <p align="center"><strong>Terms and conditions</strong></p>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 1 The subject of the Contract</strong>
</p>
<p style="margin-bottom: 0px;">The Mandator commissions and the Contractor for remuneration undertakes to perform on behalf of the Mandator such activities as:
</p>
<ol>
  <li>solid preparation and conducting online classes for all the members of the courses organised by the Mandator, in accordance with Tutore Poland school’s educational program and the schedule of classes. The schedule of classes may be in a form of an electronic file;</li>
  <li>reliable conduct of the classes record keeping, including in particular: class journals, students’ attendance lists, documentation concerning evaluation of the students, class conduct implementation reports - in a form set by the Mandator;</li>
  <li>time-bound fulfilling of all the Mandator’s organisational guidelines within the deadlines specified by the Mandator;</li>
  <li>make-up classes conducting;</li>
  <li>taking care of a proper condition of the Mandator’s property as well as tidiness and orderliness in a place of an execution of the order;</li>
  <li>cooperation with people designated by the Mandator, whereby the Contractor is obliged to regular and immediate (at the end of each working day at the latest) reading of the messages sent by these people via e-mail, sms or through instant messengers and, if necessary, responding to the information as quickly as possible, including, in particular:
    <ol type="a">
      <li>providing necessary information within the scope determined by the specific situation,</li>
      <li>participation in meetings, trainings, teacher observation interviews and evaluations;</li>
    </ol>
  </li>
  <li>cooperation with the students’ parents, especially providing them with necessary information concerning the service (e.g. giving information about homework, checking and reporting on the progress made by the students);</li>
  <li>other tasks and projects commissioned by the Mandator.</li>
</ol>
<p>In order to ensure the conditions for the performance of this contract, the Mandator agrees to provide all the necessary teaching materials, such as educational panels, graphics for presentations and an individual account in the online learning system. The above does not include electronic equipment (computer, sound system, etc.), which the Contractor shall arrange at own expense.</p>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 2 Performance of the contract</strong>
</p>
<ol>
  <li>The Contractor undertakes to perform the subject of this contract with due diligence.</li>
  <li>The performance of the subject of the contract specified in § 1 shall take place online via platforms provided by the Mandator.</li>
  <li>The Parties agree that the calculation unit shall be 60 minutes of classes according to the agreed schedule.</li>
  <li>The total number of teaching hours to be performed shall be specified in the schedule by the Mandator each time in advance and summed up at the end of each calendar month.</li>
  <li>The Parties allow the change of the dates and hours of classes specified in the schedule only upon mutual agreement.</li>
  <li>The Contractor shall perform the services covered by this contract in conditions of complete independence from the Mandator. In particular, the Mandator shall not be entitled to make use of any managerial rights over the Contractor without interfering with the organisation and/or discipline of the Contractor's work. Any technical or methodological problems regarding the entirety of the activities entrusted to the Contractor shall be resolved by mutual agreement of the Parties, respecting the independence of the Contractor's professional activities.</li>
  <li>The Contractor shall not entrust the execution of the subject matter of this contract to a third party.</li>
  <li>The Mandator with the consent of the Contractor allows commissiong the conduct of classes in the stationary unit concerted by both Parties.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 3 Information obligation</strong>
</p>
  <ol>
    <li>The Mandator shall be obliged to provide the Contractor with all information necessary for the performance of the subject of the contract.</li>
    <li>The Contractor shall be obliged to provide the Mandator with the necessary information on the course of the performance of the subject of the contract.</li>
  </ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 4 Absences and notification</strong>
</p>
<ol>
  <li>In the case of impossibility of carrying out the classes defined in §1 within the terms specified in the schedule, for reasons attributable to the Contractor, the Contractor undertakes to immediately inform the Mandator about this fact, no later than 7 days before the planned classes. In such a case, the Mandator may appoint a person to replace the Contractor in the performance of the assignment described in this contract.</li>
  <li>In the case of sudden indisposition resulting from an illness or ill health, having occurred suddenly, the Contractor may not keep the 7-day notice period of inability to perform the assignment. The Contractor agrees to notify the Mandator of such a situation immediately, no later than 4 hours after its occurrence.</li>
  <li>In the case of sudden indisposition due to an illness or ill health, having occurred suddenly, the Contractor may not keep the 7-day notice period of inability to perform the assignment, however, he/she is obliged to inform the Mandator immediately after the occurrence of such an event. The Contractor shall confirm this on the basis of an e-sick leave, which will be credited to the Principal's profile on the PUE ZUS portal.</li>
  <li>In the case of failure in carrying out the classes within the terms set in the schedule and failure in notifying the Mandator about this fact at least 7 days before the planned classes, the Mandator may terminate the contract with an immediate effect, without prior notice. In such a case, regardless of the possibility of terminating the contract, the Mandator may also claim from the Contractor a contractual penalty in the amount of 5 000 PLN (in words: five thousand PLN) for the losses suffered. The Mandator may also claim compensation exceeding the value of the stipulated contractual penalty. The above provision shall not apply to random situations that make it impossible to notify the Mandator about the inability to conduct the classes.</li>
  <li>In the case of the Contractor’s inability to conduct the classes planned according to the schedule and the Mandator’s being not able to find a substitution for the Contractor, the Contractor shall be obliged to conduct classes in the number of hours equal to the number of classes not held, so called make-up classes, at another time agreed upon in writing with the Contractor no later than 7 days from the scheduled date of classes.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 50px;">
  <strong>§ 5 Duration of the contract and notice period</strong>
</p>
<ol>
  <li>The Parties conclude the contract from ... to August 31, 2023.</li>
  <li>The Parties may terminate the contract by complying with a termination period of one month, with legal effect at the end of the following calendar month, after sending written notice of termination (except as provided in subject to sub-paragraph 3).</li>
  <li>The Mandator has the right to terminate this contract without notice if the Contractor grossly violates the provisions of this Contract, by which the Parties particularly understand:
    <ol type="a">
      <li>the behavior of the Contractor based on non-performance of the obligations set forth in § 1 of this Contract, despite a Mandator’s prior request to cease violations;</li>
      <li>the Contractor’s violation of a non-compete clause;</li>
      <li>disclosure of Confidential Information by the Contractor;</li>
      <li>any other breach of this contract.</li>
    </ol>
  </li>
  <li>In the case of termination of the contract, the Contractor undertakes to return the materials made available by the Mandator for the duration of the contract in up to 14 days from the day of termination or expiry of the contract. In the case of failure in returning the materials within the appointed period, the Mandator may impose a financial penalty proportional to the value of the received materials. Furthermore, the Contractor may be charged with the costs of the shipment.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 50px;">
  <strong>§ 6 Remuneration</strong>
  </p>
<ol>
<li>
    For proper performance of the activities listed in § 1, the Contractor will receive remuneration in the amount of: ... zl (in words: ... zlotys) gross for one lesson understood in accordance with § 2 sub-paragraph 3.
</li>
<li>In the case of having conducted a demonstration lesson, remuneration for one lesson unit (understood in accordance with § 2 sub-paragraph 3.) amounts to ... zl (in words: ... zlotys) gross.</li>
  <li>Total monthly remuneration will be resulting from sub-paragraphs 1 and 2 of this section and the number of lessons conducted in the given month, on the basis of compilation and documentation, referred to in sub-paragraph 4 of this section. In the event that in accordance with the schedule, one lesson lasts less or more than 60 minutes, the rate of remuneration will proportionally be reduced or enlarged. The Contractor is not entitled to additional remuneration for performing extra activities related to preparing, organising and reporting about the classes.</li>
  <li>The Contractor is obliged to perform and in an electronic form report to the Mandator:
    <ol type="a">
        <li>
            an overview of hours worked in a given month, generated from the tools for recording hours made available by the Mandator, <u>on the first working day of the following month at the latest</u>.
        </li>
        <li>
            Maintained documentation confirming carrying out the classes in a given month, in particular: class journals and students’ attendance lists, <u>until the last day of a month for which the Contractor is entitled to receive remuneration on account of the performed order at the latest.</u>
        </li>
    </ol>
    An overview and documentation verified by the Mandator, will form the basis of the payment of the remuneration to the Contractor. 
  </li>
  <li>The Mandator may reduce the Contractor's remuneration by up to 15% of the gross remuneration for a given month, in the event of the Contractor's non-compliance with the provisions contained in this contract, in particular: in meeting the specified availability, lateness for classes, failure in answering the e-mails and telephone calls from people specified by the Mandator to be contacted, justified parents’ complaints about the quality of lessons, failure in meeting the obligation to assess children within the framework of reports, failure in following the principles of personal culture during the classes and when contacting the people indicated by the Mandator, failure in meeting the guidelines concerning the programme and quality of educational sessions determined by the Mandator.</li>
<li>The Contractor’s remuneration shall be paid in arrears on a monthly basis, up to the 15th day of the following calendar month, by bank transfer to a bank account specified by the Contractor.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 25px;">
  <strong>§ 7 Bonus</strong>
</p>
<ol>
  <li>The Mandator may grant the Contractor the appreciation premium in the amount up to 15% of gross remuneration. The grant of the premium is dependent of the performance level of the commissioned individual assignments. Individual assignments for the following month shall be presented sufficiently in advance.</li>
  <li>Furthermore, the Mandator may grant the additional appreciation bonus for other goals, not in connection with sub-paragraph 1 of this paragraph.</li>
  <li>The bonus is not of a claim nature, whereas its granting and determination of its amount lies on the side of the Mandator.</li>
  <li>Calculation and payment of the bonus take place within 15 days from the end of the monthly settlement period.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 8 Confidential information</strong>
</p>
<ol>
  <li>Under Confidential Information the Parties shall understand all information submitted to the Contractor by the Mandator or obtained by the Contractor in a way different than in connection with the performance of this contract, including technical, technological, organisational or other information having economic value, concerning the Mandator and his business, and in particular the teaching materials utilised by the Mandator, the contact database to the Mandatorl's customers (including customers who terminated their cooperation with the Mandator up to 12 months after the end of the contract), computer systems and other information obtained from the Mandator in the course of performance of the contract.</li>
  <li>The Contractor agrees that Confidential Information obtained within the framework of this contract shall be kept confidential by the Contractor and used solely for the performance of this contract. The Confidential Information shall not be used for other purposes nor disclosed or made available to third Parties, in whole or in part. The obligation of confidentiality applies to Confidential Information obtained by the Contractor from the Mandator in writing and disclosed to the Contractor orally, visually, electronically or otherwise. The Contractor agrees to keep the received Confidential Information secretly and not to disclose it to anyone without written consent.</li>
  <li>Upon the termination of cooperation between the Parties, or before its termination - at each request of the Mandator - the Contractor shall within 3 days be obliged to return to the Mandator all Confidential Information, together with the documentation and other storage media on which the before-mentioned were recorded, as well as copies of the documentation or storage media containing such Information. The Contractor undertakes to delete from the computers’ memory and other devices all received or created materials in a manner that prevents their reproduction and use in any form in the future.</li>
  <li>In case of the Contractor’s violation of the preceding sub-paragraphs, in particular, through non-contractual disclosure or making available the materials and Confidential Information, the Contractor will be obliged to pay the Mandator a contractual penalty in the amount of 5 000, 00 zl (in words: five thousand zlotys) for each and every such violation. Such fine will be payable within 14 days from the date of the Maandator’s submission of a statement of imposing the contractual penalty on the Contractor.</li>
  <li>If the amount of damage or the Mandator’s opportunity, resulting from a breach of the provisions of this contract by the Contractor, exceeds the amount of the contractual penalty indicated in sub-paragraph 4 of this paragraph, the Mandator may seek supplementary compensation on general principles stemming from Civil Code.</li>
  <li>For violation of the provisions described in this contract, the Mandator shall also understand each and every utilization of the Mandator’s educational materials for the Contractor’s private use and for the purpose of teaching people who are not the Mandator’s Clients.</li>
  <li>Regardless of the expiry or termination of this contract, the Contractor's obligations to keep Confidential Information confidential shall remain in force for an indefinite period.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 30px;">
  <strong>§ 9 Non-compete clause</strong>
</p>
  <ol>
    <li>According to this section, the competitive activity shall be understood by the Parties as: offering and providing any educational services related to teaching in any form to clients of the Principal who have contracted with the Mandator no later than on the day of this contract’s expiry.</li>
  <li>Competitive activities shall also be deemed to include:
    <ol type="a">
      <li>the Contractor’s performance of work on behalf of the entity conducting competitive business in relation to the Mandator, the Contractor’s performance of services on the basis of whatever civil-law agreement on behalf of the entity conducting competitive business in relation to the Mandator,</li>
      <li>the Contractor’s running a entrepreneurship performing competitive business in relation to the Mandator, also through a third person,</li>
      <li>being a partner in a company conducting competitive business in relation to the Mandator,</li>
      <li>being a member of bodies of entities engaged in competitive business in relation to the Principal,</li>
      <li>functioning as an agent, proxy or attorney-in-fact of entities conducting business competitive in relation to the Mandator.</li>
    </ol>
  </li>
  <li>The Contractor undertakes not to conduct competitive business in relation to the Mandator’s business as defined in sub-paragraph 1 of this section during the cooperation described in sub-paragraph 1 of this section.</li>
  <li>If it is the Client, who is a current Client of the Mandator , who makes a proposition of cooperation to the Contractor, the Contractor is obliged to inform the Client about the above mentioned prohibition of competitive activity, refuse to start cooperation  and is obliged to inform the Mandator about the situation.</li>
  <li>The Mandator reserves the right to, in regard to the Contractor, check whether the provisions of this section are properly performed by the Contractor.</li>
  <li>For each and every breach of the non-compete clause reffered to in this contract, the Mandator may charge the Contractor with a penalty of 20 000 zl (in words: twenty thousand zlotys). In such case, the Mandator may also  claim compensation exceeding the value of the stipulated contractual penalty.</li>
  </ol>
  <br>

<p align="center" style="margin-bottom: 0px; margin-top: 30px;">
  <strong>§ 10 Delivery and correspondence, consent to use image, GDPR</strong>
</p>
<ol>
  <li>The Parties agree that unless written notice of a change of address for correspondence is given, all correspondence addressed to the addresses given in the Designation of Parties shall be deemed to have been delivered no later than the date of the second advice of delivery.</li>
  <li>Electronic mail addresses are provided in the Designation of Parties. An electronically sent letter shall be deemed delivered when the other party has had an opportunity to review it.</li>
  <li>The Contractor consents to the use of personal image, as specified in the appendix to this agreement.</li>
  <li>The Contractor shall comply with the provisions of Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC (GDPR) and the Act of 10 May 2018 on personal data protection (Journal of Laws of 2019, item 1781 as amended). The Contractor agrees to the processing of his personal data, in accordance with the information clause annexed to this contract.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 15px;">
  <strong>§ 11 Disputes and competent court</strong>
</p>
<p>The Parties declare that they will make every effort to resolve any disputes arising from this contract amicably. In case of disputes that cannot be resolved amicably within 14 days from the date of the other party’s reception of a written request for such amicable resolution, the disputes shall be submitted for settlement to the court having jurisdiction over the Mandator’s seat.</p>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 12 Completeness and amendment of the contract</strong>
</p>
<ol>
  <li>This Agreement shall terminate and supersede all other previous written or oral arrangements, understandings, and settlements of the Parties within the scope hereof, which are hereby terminated.</li>
  <li>The Parties declare that apart from this contract, there are no additional arrangements or agreements concerning the subject of this contract between them.</li>
  <li>Any amendments to this contract shall be made in writing under pain of nullity.</li>
  <li>Termination of this contract shall be in a written form under pain of nullity.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 13 Salvatory clause</strong>
</p>
<p>
If any provision of this Contract proves to be invalid in whole or in part, the other provisions shall remain in force and the Parties undertake, at the request of either of them, to replace the invalid provision with the ones having the closest legal force and economic effect to the one being replaced.</p>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 14 Applicable law</strong>
</p>
<ol>
  <li>This Contract shall be governed by the laws of the Republic of Poland.</li>
  <li>In matters not covered by this Contract, relevant provisions of the law, in particular the provisions of the Civil Code shall apply.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 15 Number of copies of the contract</strong>
</p>
<p>This Contract has been composed in two legally equal copies, one for each party.
  <br>
</p>
<br>

 <div>
  <p class="underline">The attachments functioning as an integral part of the contract:</p>
  <ol>
    <li class="underline">Consent for use of image</li>
    <li class="underline">GDPR information clause</li>
    <li class="underline">Authorisation to process personal data</li>
    <li class="underline">Information about the monitoring of on-line classes</li>
    <li class="underline">The Contractor’s statement</li>
  </ol>
</div>

<div class="cointainer" style="margin-top: 30px;">
    <div class="left-cointainer">
        <span style="margin-left: 0%;">...</span><br>
        <span style="margin-left: 0%;">(The Mandator’s signature)</span>
    </div>
    <div class="right-cointainer">
        ...<br>
        <span style="margin-left: 0%;">(The Contractor’s signature)</span>
    </div>
</div>
<br>

<div style="page-break-before: always; position: relative; top: -3px;">
   <p><strong>Annex No. 1 CONSENT TO USE OF IMAGE</strong></p>
   <p>I hereby declare that I grant Tutore Poland Sp. z o.o., with registered office in Łódź at Piotrkowska 157A, 90-440, KRS 0000670834, NIP: 727-28-12-193, REGON: 366891567, (hereinafter referred to as Tutore Poland Sp. z o.o.) permission, free of charge, to repeatedly use and disseminate my image in the form of a photograph in connection with the performance of the contract of mandate in order to place it in the company's e-mail footer. The image will only be used for the duration of the contract in the form of a photograph in an email correspondence sent on behalf of the Principal.</p>
   <p>I also hereby declare that I give my consent to Tutore Poland Sp. z o.o. for free recording and unlimited time and territory multiple use and dissemination of my voice or statements recorded during the performance of this agreement for the provision of services through telephones with VoIP connection (Voice over Internet Protocol).</p>
   <p>This consent covers the following fields of exploitation: use, recording, processing and duplication of images/recordings made, trading in copies on which my image or voice was recorded and multiplication of image/voice with all available techniques and methods, dissemination and publication, in materials serving the activities of Tutore Poland in particular in training, educational and promotional materials in any form.</p>
   <p>Tutore Poland Sp. z o.o. has the exclusive right to decide on the form and time of using my image, voice, and speech in whole or in the form of any fragments. The image may be used for various forms of electronic image processing, framing and composition, without the obligation of accepting the final product, but not in forms that are offensive or generally considered unethical.</p>
</div>

<div style="page-break-before: always; position: relative; top: -3px;">
  <p><strong>Annex 2. INFORMATION CLAUSE</strong></p>
  <p>Information clauses from Article 13 GDPR</p>
  <p>According to Article 13(1) and (2) of Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons about the processing of personal data and the free movement of such data and repealing Directive 95/46/EC (General Data Protection Regulation) (Official Journal of the EU L 119 of 04.05.2016, p. 1), hereinafter "GDPR", I inform you that:</p>
  <p style="margin-bottom: 10px;">The Administrator of Your Personal Data is Tutore Poland Sp. z o.o., with its registered office in Łódź at Piotrkowska 157A, 90-440, KRS 0000670834, hereinafter: "PDA".</p>
  <p style="margin-bottom: 10px;">You may contact PDA by writing to Tutore Poland Sp. z o.o, ul. Piotrkowska 157A, 90-440, e-mail kadry@tutore.eu and by contacting the Data Protection Officer at the e-mail address: mlokaj@mlkancelaria.com</p>
  <p>PDA processes personal data for the following purposes:</p>
  <ol type="a">
    <li>establishing cooperation - Art. 6(1)(b), (f) GDPR,</li>
    <li>ensuring contact between the Parties (email address, telephone number) - Art. 6 (1) lit. b, f GDPR,</li>
    <li>fulfilment of rights and obligations arising from the service contract - Art. 6(1)(b), (c), (f) GDPR,</li>
    <li>keeping a record of correspondence - Art. 6(1)(c, f) GDPR,</li>
    <li>record keeping of the course of cooperation (including payment processing) - Art. 6(1)(b, c) GDPR,</li>
    <li>the assertion of claims and rights - Art. 6(1)(b, f) GDPR,</li>
    <li>fulfilment of tax obligations - Art. 6(1)(b, c) GDPR,</li>
  </ol>
  <br>
  <p style="margin-bottom: 10px;">Recipients of personal data are entities to whom PDA has entrusted the processing of personal data, in particular: providers of technical and organisational services, providers of accounting, HR, legal and advisory services, banks (payment processing), public authorities within the framework of the fulfilment of duties related to the conduct of business activities by PDA.</p>
  <p style="margin-bottom: 10px;">PDA does not transfer personal data outside the European Economic Area. Personal data shall be stored for the period of execution of the agreement, and then for the period determined by generally applicable laws, including in particular: claim enforcement (period of limitation of claims), maintenance of accounting books and tax documentation (5 years from the end of the calendar year in which the tax obligation arose).</p>
  <p style="margin-bottom: 10px;">The person whose data is processed has the right to access his/her data and to receive a copy of it, the right to rectify (amend) his/her data, the right to erasure, the right to withdraw consent, the right to restrict processing, the right to be forgotten, the right to object, the right to data portability, the right to lodge a complaint with the Office for Personal Data Protection.</p>
  <p style="margin-bottom: 10px;">The provision of personal data by You and Your consent to their processing and dissemination of your image is voluntary, but it is a necessary condition for the establishment of cooperation and the possible conclusion of a written agreement and the exercise of rights and obligations by PDA.</p>
  <p style="margin-bottom: 10px;">Within the scope of PDA's activities, no automated decision-making, including profiling, takes place using the collected personal data.</p>
  <p style="margin-bottom: 10px;">Scope of data subject to processing: name, email address, telephone number, image, PESEL.</p>
  <p style="margin-bottom: 10px;">...</p>
  <p style="margin-bottom: 10px;">Signature</p>
  </div>

<div style="page-break-before: always;">
  <div class="cointainer" style="margin-top: 60px;">
    <div class="left-cointainer">
      <p><em>Attachment No. 3</em></p>
    </div>
    <div class="right-cointainer">
      <p style="margin-bottom: 10px; font-size: 14px;">
    Łódź, {{ aktualnaData() }}
      </p>
    </div>
</div>
  
  
<p align="center" class="subheading" style="margin-bottom: 10px;">
  <strong>
    Supplementary authorisation<br>
    to process personal data in the filing system<br>
    in paper and electronic versions
  </strong>
</p>
<p class="p-margin">
  Pursuant to Article 29 of Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data and repealing Directive 95/46/EC (General Data Protection Regulation), hereinafter referred to as GDPR, I hereby:
</p>
<p class="p-margin">
  as of the date of signing of the authorization by both parties,
</p>
<p class="p-margin">
  I authorize Mr./Ms ... Contractor Tutore Poland Sp. z o.o.
</p>
<p class="p-margin">
  realizing the contract of mandate by teaching the subject English Language in the Education Department
</p>
<p class="p-margin">
  to process personal data contained in the following sets of personal data:
</p>
  <ol type="a">
    <li>in the electronic version:
      <ul>
        <li>
          set of personal data of Customers: parents (legal guardians) of children, adolescents and adults using services offered by Tutore Poland - name and surname, address of residence, contact telephone number, e-mail address,
        </li>
        <li>
          set of personal data of Customers: children, youth and adults using services offered by Tutore Poland - name and surname, address of residence, contact telephone number, e-mail address.
        </li>
      </ul>
    </li>
  </ol>
<p class="p-margin">
  in the scope of accessing, introducing, modifying, deleting and archiving personal data covered by the above-mentioned collections.
</p>
<p class="p-margin">
  This authorisation does not authorise further authorisations and expires on the date of termination of the assignment agreement, and may be amended or revoked at any time.
</p>
<p>
  I oblige you to process the personal data contained in the aforementioned sets of personal data to the extent and in the manner required for the fulfilment of your official duties towards the Principal - Personal Data Administrator. I oblige you to process personal data in accordance with the authorisation granted, the Regulation (EU)2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data and repealing Directive 95/46/EC ( Official Journal of the EU L 119, p.1) and the provisions of the Act of 10 May 2018 on the protection of personal data (Journal of Laws of 2018, item 1000) and the internal regulations in force at Tutore Poland Sp. z o.o.on the protection of personal data.
  <br>
  Violation of the above-mentioned obligations may result in criminal liability and constitutes grounds for termination of the assignment contract.
</p>

<div class="container" style="page-break-before: always;">
    <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
      <tr>
        <td id="oswiadczenie">
          <p align="center" class="subheading"><strong>CONTRACTOR'S DECLARATION</strong></p>
          <ol>
        <li>I, the undersigned, declare that:
        <ol type="a">
          <li>
            I have read and I acknowledge the content and scope of the authorisation,
          </li>
          <li>
            the content of the authorisation is clear and comprehensible to me and any doubts have been comprehensively explained to me by the authorised person,
          </li>
          <li>
            I undertake to process the personal data contained in the aforementioned personal data files to the extent and in the manner required to fulfil my duties towards the Principal,
          </li>
          <li>
            I undertake to process the personal data in accordance with the authorisation granted, the GDPR regulations and the internal procedures in force at the Employer, including the Privacy Policy,
          </li>
          <li>
            I undertake to keep in secret the personal data to which I have or will have access in relation to the performance of duties for the benefit of Tutore Poland Sp. z o.o., and to keep in secret the ways of securing personal data, also after revoking or changing the authorization, and also after the termination of the contract of mandate.
          </li>
        </ol>
        </li>
        </ol>
          <div class="right-cointainer" style="float: right; margin-top: 20px;">
        <span style="font-size: 14px;">...</span>
        <br>
        <span>legible signature of the Contractor</span>
        </div>
      </td>
    </tr>
  </table>
  </div>

<p class="subheading p-margin" style="text-align: center;">
  {{ zamawiajacy }}
  <br>
  <strong>on behalf of the Administrator</strong>
</p>
<br>
<p>This authorisation was revoked on the date of termination of the contract of mandate.</p>
</div>

<div style="page-break-before: always;">
  <p><em>Annex 4</em></p>
  <p class="subheading" style="margin-bottom: 0px;"><strong>Information on the monitoring of on - line activities and the recording of on - line internal training</strong></p>
  <br>
  We would like to inform you that Tutore Poland Sp. z o.o. uses technical means of monitoring online classes and recording internal online training. The monitoring includes Video and audio recording devices used by the user for online activities, i.e. the Clickmeeting platform or the Zoom application. Clickmeeting platform or the Zoom application, and in the case of internal online training, the Zoom application. Tutore Poland Sp. z o.o. uses monitoring for the following purposes: to ensure the highest standards of service of lessons delivered by employees/contractors, to ensure the correctness of performance of assigned activities and possible improvement of the quality of lessons, and to safeguard the interests of the company in situations of disputes with the customer (evidence), and in the case of internal on - line training to ensure that the recordings can be made available to new employees/contractors. We would like to inform you that: the audio-visual and audio monitoring system for online classes consists of the recording system of the Clickmeeting or Zoom platform and the server on which the online classes are recorded, access to the recording of online classes is provided to persons authorised by the Management Board of Tutore Poland Sp. z o.o., i.e. Manager of the Call Centre Department, Director of Process Management, Teamleader of the Call Centre Department, persons who have access to the recorded image are aware of their responsibility for personal data protection and have the relevant authorisation issued by the Personal Data Administrator. In the course of the recording, processing of personal data in the form of voice, image and name of the employee/contractor conducting the class or training takes place. The Administrator of personal data obtained in the course of on - line classes' monitoring and in the course of recording of internal on - line training is Tutore Poland Sp. z o.o., which, in connection with the activity described above, publishes the required information clause on personal data processing below.
</div>

<div style="margin-top: 40px; font-size: 10px;">
  <p align="right" style="font-size: 14px; margin-bottom: 0;">
        Łódź, {{ aktualnaData() }}
      </p>
        <p style="font-size: 14px; margin-bottom: 0;">...</p>
        <p style="font-size: 14px;">Name and surname of the Contractor</p>
<p align="center" class="subheading">
  <strong>INFORMATION ON PERSONAL DATA PROCESSING</strong>
</p>
<ol>
  <li>
    I would like to inform you that the Administrator of Your data as a Contractor is Tutore Poland Sp. z o.o. with its registered office at Piotrkowska 157A, 90-440 Łódź, KRS: 0000670834, NIP: 7272812193, tel. 500 965 135, info@tutore.eu.
  </li>
  <li>
    By providing you with this information on the processing of personal data, the Administrator is complying with the legal obligation under Article 15(1) of Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data and repealing Directive 95/46/EC (General Data Protection Regulation), hereinafter referred to as GDPR.
  </li>
  <li>
    The controller obtains information about you in connection with a statutory obligation, which is necessary for the effective implementation of the cooperation process. Concerning personal data not affected by the statutory condition of necessity - their provision is voluntary.
  </li>
  <li>
    Your personal data shall be processed for the following purposes, on the following basis and for the following period:
    <ol type="a">
      <li>
        conclusion and execution of a civil law contract - in order to comply with the obligation under the Civil Code (Article 6(1)(b), (c), (f) GDPR) - for the period of cooperation,
      </li>
      <li>
        calculation and payment of remuneration - in order to comply with the obligation under the Civil Code (Article 6(1)(c), Article 9(2)(b) GDPR) - for the period of cooperation,
      </li>
      <li>
       salary deductions - in order to comply with salary enforcement obligations under the Civil Procedure Code, the Administrative Enforcement Proceedings Act, and the Bailiffs Act (Article 6(1)(c) of the DPA) - for the period prescribed by generally applicable law,
      </li>
      <li>
        fulfilment of tax obligations - in order to fulfil the obligations of an income tax payer under the Tax Ordinance, the Personal Income Tax Act and other tax regulations (Article 6(1)(c) GDPR) - for a period of 5 years from the end of the calendar year,
      </li>
      <li>
        fulfilment of obligations towards the Social Insurance Institution (ZUS) - in order to fulfil obligations of a payer of social and health insurance contributions resulting from the Act on pensions from the Social Insurance Fund, the Act on the social insurance system and the Act on healthcare benefits financed from public funds (Article 6(1)(c), Article 9(2)(b) GDPR) - for a period of 5 years from the end of the calendar year,
      </li>
      <li>
        fulfilment of accounting obligations - in order to fulfil obligations under the Accounting Act, the Tax Code and the Corporate Income Tax Act (Article 6(1)(c) GDPR) - for a period of 5 years from the end of the accounting year in which the event occurred,
      </li>
      <li>
        physical security of the Administrator's buildings, premises and property - based on the Administrator's legitimate interest (Article 6(1)(f) GDPR) - for the period of cooperation,
      </li>
      <li>
        to ensure the highest standards of service of the lessons provided by the Collaborators via the ClickMeeting or Zoom platform, the correctness of the performance of the entrusted activities and the possible improvement of the quality of the lessons, safeguarding the interests of the company in situations of disputes with the client (evidence) by monitoring and recording online courses - based on the voluntary consent of the recorded person (Article 6(1)(a) GDPR) - the Image and voice of the Collaborator will be processed for a period of 3 months. Where the recordings of the recorded classes constitute evidence in proceedings under the law or the Administrator has become aware that they may constitute evidence in the proceedings, this period shall be extended until the proceedings have become final. After the expiry of these periods, the recordings containing personal data shall be destroyed,
      </li>
      <li>
        to ensure that recordings can be made available to new Employees and Associates by recording online training sessions conducted using the Zoom platform - based on the voluntary consent of the person being recorded (Article 6(1)(a) of the GDPR) - the Image and voice of the Associate will be processed until the consent is withdrawn. If consent is withdrawn, recordings containing personal data shall be destroyed,
      </li>
      <li>
        to ensure the highest standards of customer service quality, for training purposes - enabling the improvement of service quality, to safeguard the company's interests in situations of disputes with customers (evidence), to ensure the safety of Co-workers in the event of undesirable and dangerous events on the part of customers (e.g. criminal threats) by monitoring telephone conversations with the Administrator's customers - based on the Administrator's legitimate interest (Article 6(1)(f) GDPR) - for a period of up to 3 months. Where the recordings of the recorded telephone conversations constitute evidence in a proceeding conducted on the basis of legal regulations or the Administrator has become aware that they may constitute evidence in the proceeding, this period is extended until the proceeding is legally concluded. After the expiry of these periods, recordings containing personal data shall be destroyed,
      </li>
      <li>
        creating photo-reports from camps for children and young people on a memory stick for Customers, facebook fanpage and the website www.musicandmore.pl - based on the voluntary consent of the recorded person (Article 6(1)(a) GDPR) - the image and voice of the Co-worker will be processed until the consent is withdrawn. If consent is withdrawn, recordings containing personal data shall be destroyed,
      </li>
      <li>
        pursuing claims or defending against claims - based on the Administrator's legitimate interest (Article 6(1)(f) GDPR) consisting in appearing in court cases - in the case of pending proceedings, for the duration of the proceedings until their final conclusion and for the period determined by generally applicable laws.
      </li>
    </ol>
  </li>
  <li>
    The recipients of your personal data will be:
    <ul>
      <li>
        public administration authorities (e.g. Social Insurance Institution, Tax Offices) - by virtue of the relevant legislation;
      </li>
      <li>
        Health care facilities for occupational health purposes;
      </li>
      <li>
        external entities providing and supporting the Employer's ICT systems (both general ICT infrastructure, electronic mail and IT systems used by the Employer for HR and financial services or circulation of documents related to employment) - by virtue of relevant personal data processing entrustment agreements and ensuring that the above entities apply adequate technical and organisational measures to ensure data protection,
      </li>
      <li>
        accounting offices:
      </li>
      <li>
        banks - for the purpose of payment of salaries and other monetary benefits to the Principal in case of their payment with the consent of the Contractor to a bank account;
      </li>
      <li>
        contractors - for the purpose of enabling contractors (potential and current) to contact them or for the day-to-day execution of contracts concluded and related to the Contractor's position; 
      </li>
      <li>
        co-workers of the Contractor, who provide services to Tutore Poland Sp. z o.o., to enable the co-workers to contact the Contractor,
      </li>
      <li>
        entities providing additional services to the Contractors, only if the Contractor uses these services.
      </li>
      <li>
        insurance institutions
      </li>
      <li>
        foreign administration organisations in the EU countries where the contract is performed (applies to the performance of the contract abroad)
      </li>
      <li>
        entities providing training and performing health and safety duties (if there is no health and safety unit at the Contractor's premises).
      </li>
    </ul>
  </li>
  <li>
    You have the right to:
    <ol type="a">
      <li>
        <strong>Access to data</strong> — to obtain confirmation from the Administrator as to whether your personal data are being processed. If data is being processed, you are entitled to access the data (Article 15 GDPR);
      </li>
      <li>
        <strong>to obtain a copy of the data</strong> — to obtain a copy of the data being processed, the first copy is free of charge and for subsequent copies, the relevant Controller may charge a reasonable fee based on administrative costs (Article 15(3) GDPR);
      </li>
      <li>
        <strong>rectification</strong> — request the rectification of personal data that is inaccurate or the completion of incomplete data (Article 16 GDPR);
      </li>
      <li>
        <strong>erasure</strong> — request the erasure of personal data where the Controller no longer has a legal basis for the processing or the data are no longer necessary for the purposes of the processing (Article 17 GDPR);
      </li>
      <li>
        <strong>restriction of processing</strong> — request the restriction of the processing of personal data (Art. 18 GDPR) when:
        <ol type="i">
          <li>
            you contest the accuracy of the personal data - for a period allowing the Administrator to verify the accuracy of the data,
          </li>
          <li>
            the processing is unlawful, and you object to the erasure of the data by requesting the restriction of its use,
          </li>
          <li>
            The Administrator no longer needs the data, but it is for you to establish, assert or defend your claims;
          </li>
          <li>
            you have lodged an objection to the processing - until it is determined whether the legitimate grounds on the part of the Administrator override the grounds for your objection;
          </li>
        </ol>
      </li>
      <li>
        <strong>data portability</strong> — to receive in a structured, commonly used machine-readable format the personal data concerning you provided to the Controller, and to request that this data be sent to another Controller where the data is processed on the basis of your consent, or a contract concluded with you, and where the data is processed by automated means (Article 20 GDPR);
      </li>
      <li>
        <strong>objection</strong> — to object to the processing of personal data for the legitimate purposes of the Controller, on grounds related to your particular situation, including profiling. The Controller shall assess the existence of valid legitimate grounds for the processing, overriding your interests, rights and freedoms or grounds for establishing, pursuing or defending claims. If according to the assessment, your interests outweigh the interests of the Controller, the Controller will be obliged to stop processing the data for these purposes (Article 21 GDPR);
      </li>
      <li>
        <strong>the right to lodge a complaint with the supervisory authority</strong> – the President of the Office for the Protection of Personal Data, if you consider that the processing of personal data concerning you is in breach of the law. Complaints can be submitted in the form of:
        <ul>
          <li>
            in writing to the address: 2 Stawki Street, 00-193 Warsaw,
          </li>
          <li>
            electronically via the ePUAP platform.
          </li>
        </ul>
      </li>
    </ol>
  </li>
  <li>
    In the course of the processing of personal data, there is no exclusively automated decision-making or profiling as referred to in Article 22(1) and (4) of the GDPR, which means that no decisions concerning you will be made automatically and no profiles of you will be created.
  </li>
  <li>
    You are obliged to inform the Principal of any changes concerning your personal data provided to the Principal in accordance with the Agreement.
  </li>
</ol>
</div>

<div style="page-break-before: always;">
  <div class="container">
    <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
      <tr>
        <td id="oswiadczenie">
          <p align="center" class="subheading"><strong>DECLARATION BY THE EMPLOYEE/CONTRACTOR</strong></p>
          <ol>
        <li>I, the undersigned, declare that:
        <ol type="a">
          <li>I have read and acknowledge the Information on the monitoring of classes on - line and the recording of internal training on - line and the Information Clause,</li>
          <li>the content of the Information and Clause is clear and comprehensible to me, and any doubts have been explained to me in a comprehensive manner by an authorised person.</li>
          </ol>
          </li>
          <li>On a completely voluntary basis, I agree to the processing of my personal data for the purposes indicated in the Information on the monitoring of on - line activities and the recording of internal on - line training.</li>
          <li>I have been informed that my personal data are processed on the basis of my freely given consent and that I have the right to withdraw it at any time, whereby the withdrawal of consent shall have legal effect from the moment of its submission and shall not affect the processing of my personal data for purposes related to the implementation of the study prior to the submission of the statement of withdrawal of consent.</li>
          <li>Pursuant to Article 81, paragraph 1 of the Act on Copyright and Related Rights, I consent to the dissemination of my image by Tutore Poland Sp. z o.o. for the purposes indicated in the Information on the monitoring of classes on - line and recording of internal training on - line.</li>
          </ol>
          <div style="float: right; margin-top: 20px;">
        <span style="font-size: 14px;">...</span>
        <br>
        <span>legible signature of the Employee/Contractor</span>
        </div>
      </td>
    </tr>
  </table>
  </div>
  </div>

</td>
</tr>

</tbody></table>

<div style="margin-top:5px;page-break-before: always;">
  <p><em>Załącznik nr 5 / Annex 5</em></p>
  <p align="center" class="subheading"><strong>Oświadczenie Zleceniobiorcy / Declaration by the Contractor</strong></p>

  <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
  <tbody>

  <tr>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center; width: 300px;">
  <p class="cell-in-first-table"><span><strong>DANE OSOBOWE / PERSONAL DATA</strong></span></p>
  </td>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>DO WYPEŁNIENIA / TO FILL</strong></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Data / Date</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Imiona i Nazwisko/ Name, Middle Name and Surname</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer PESEL / PESEL number</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Seria i numer dowodu osobistego (proszę podać w przypadku braku nr PESEL)/ Passport number (if no PESEL number has been issued)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Obywatelstwo / Nationality</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer telefonu / Phone number</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres e-mail / E-Mail address</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table">
    <span>Adres zamieszkania</span>
    <br>
    <span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span>
    <br>
    <span>Residential address</span>
    <br>
    <span class="caption"> (street, house number, ZIP code, town)</span>
  </p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table bigCell"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table">
    <span>Adres korespondencyjny</span>
    <br>
    <span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span>
    <br>
    <span>Correspondence address</span>
    <br>
    <span class="caption"> (street, house number, ZIP code, town)</span>
  </p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table">
    <span>Urząd Skarbowy</span>
    <br>
    <span>(zgodny z adresem zamieszkania)</span>
    <br>
    <span>Revenue office</span>
    <br>
    <span>(compatible with residential address)</span>
    </p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table bigCell"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer rachunku bankowego / Bank account number</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>OŚWIADCZAM, ŻE: / I DECLARE, THAT:</strong></span></p>
  </td>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>ODPOWIEDZI: „TAK” lub „NIE”<br>(lub opis, jeśli jest wymagany) / ANSWERS "YES" OR "NO"<br>(or description if required)</strong></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>1. Jestem emerytem / I'm retired</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>2. Jestem rencistą / I am a pensioner</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3. Posiadam orzeczenie o stopniu niepełnosprawności / I have a certificate of the degree of disability</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3.1. Jeśli wpisano "TAK", proszę określić orzeczony stopień niepełnosprawności / Please select the certified degree of disability or select "not applicable"</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>4. Jestem uczniem/studentem do 26 roku życia<br>(jeśli wpisano "TAK", proszę pominąć pkt. 5,6,7) / I am a student up to the age of 26 (please skip point 5,6,7 if "YES" was selected)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>5. Wnoszę o dobrowolne ubezpieczenie chorobowe<br>(tylko w przypadku objęcia ubezpieczeniem emerytalnym i rentowym) / I am applying for voluntary sickness insurance (only in the case of being covered by retirement and disability pension insurance)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6. Jestem zatrudniony/a na umowę o pracę lub umowę zlecenie<br>(Jeśli wpisano "TAK", proszę uzupełnić poniższe dane) / I am employed under an employment contract / contract of mandate in a workplace other than Tutore Poland Sp. z o. o. (please fill in the points below if you answer YES) </span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.1. Nazwa i adres pracodawcy / Name and address of the employer</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.2. Wynagrodzenie z tytułu umowy o pracę/umowy zlecenie<br>jest wyższe bądź równe krajowej płacy minimalnej / The salary for an employment contract / mandate contract elsewhere than Tutore Poland is higher than or equal to the national minimum wage</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7. Podlegam ubezpieczeniu społecznemu z innego tytułu<br>niż umowa o pracę i/lub umowa cywilno-prawna z Tutore Poland Sp. z o.o. / I am subject to social insurance for reasons other than the mandate contract with Tutore Poland Sp. z o.o.</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7.1. W przypadku odpowiedzi: TAK, proszę określić tytuł ubezpieczenia / If the answer is: YES in point 7, please specify the insurance title</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td colspan="2" style="border: 1px solid; background-color: #a4c2f4; text-align: center; font-size: 10px">
  <p class="cell-in-first-table"><span><strong>
  Wypełnienie powyższego oświadczenia oznacza deklarację zgodności wypisanych danych ze stanem prawnym oraz faktycznym,oraz świadomość odpowiedzialności karnej za zeznanie nieprawdy lub zatajenie prawdy.
  <br/>
  Zobowiązuję się do poinformowania Pracodawcy w przypadku zmiany ww. danych w terminie 7 dni od daty zaistnienia zmiany. Wyrażam zgodę na podanie Administratorowi danych osobowych mojego numeru telefonu, adresu e-mail i adresu do korespondencji w Oświadczeniu Zleceniobiorcy, celem wysyłki rocznych deklaracji rozliczeniowych.
  <br/>
  </strong></span></p>
  <p class="cell-in-first-table"><span><strong>
    By completing the above statement, you agree to provide Tutore Poland Sp. z o.o. telephone number, e-mail address and correspondence address, as well as a declaration of compliance of the provided data with the legal and factual status, and awareness of criminal liability for declaring untruth or concealing the truth.
  <br/>
    I undertake to inform the Principal in the event of a change in the above-mentioned data within 7 days from the date of the change.
  <br/>
  </strong></span></p>
  </td>
  </tr>

  </tbody>
  </table>
</div>
    
<div style="margin-top: 5px;page-break-before: always;">
  <p><em><b>Załącznik nr 6</b></em></p>
  <p class="subheading" style="margin-bottom: 0px;"><strong>OGÓLNE ZASADY BHP PRZY PRACY ADMINISTRACYJNO-BIUROWEJ</strong></p>
  <br>
  <p>Bezpieczne warunki pracy są zapewnione, gdy:</p>
  <ul>
    <li>Zapewniona jest dostatecznie duża powierzchnia stanowiska pracy (co najmniej 2m wolnej powierzchni podłogi).</li>
    <li>Jest właściwe oświetlenie (w zależności od charakteru pracy min. 300lx).</li>
    <li>Jest dostateczna wentylacja pomieszczenia (naturalna lub mechaniczna); wilgotność względna powietrza nie powinna być mniejsza niż 40%.</li>
    <li>Jest wystarczające ogrzewanie w okresie jesienno-zimowym (min. +18°C)</li>
    <li>Są dostępne i w dobrym stanie urządzenia higieniczno-sanitarne oraz dobry stan techniczny mebli, sprzętu i innych urządzeń.</li>
  </ul>
  <p>Podstawowe czynności, które należy wykonać przed rozpoczęciem pracy:</p>
  <ul>
    <li>Zaplanować  kolejność wykonywania poszczególnych czynności, przygotować potrzebne dokumenty i programy.</li>
    <li>Ustawić ekran monitora względem źródeł światła tak, aby ograniczyć olśnienie i odbicia światła.</li>
    <li>Sprawdzić stan techniczny mebli, sprzętu, urządzeń, stan oświetlenia stanowiska pracy.</li>
    <li>Zaznajomić się dokładnie z instrukcją obsługi i instrukcją bezpiecznej pracy sprzętu elektrycznego i elektronicznego używanego w trakcie wykonywania pracy (komputer, drukarka, itp.).</li>
    <li>Odpowiednio dla siebie dopasować krzesło i przygotować stanowisko pracy.</li>
  </ul>
  <p>Czynności, które należy wykonywać podczas pracy:</p>
    <ul>
    <li>Utrzymywać ład i porządek na stanowisku pracy.</li>
    <li>Zachowywać ostrożność przy używaniu urządzeń elektrycznych.</li>
  </ul>
  <p>Czynności zabronione:</p>
  <ul>
    <li>Dopuszczenia do użytkowania urządzeń osób nieupoważnionych.</li>
    <li>Otwierania osłon podczas pracy urządzeń.</li>
    <li>Używania niesprawnych bądź uszkodzonych urządzeń, względnie instalacji elektrycznej (np. zniszczona izolacja na przewodach, stłuczone wtyczki lub gniazdka, prowizorycznie połączone przewody). </li>
  </ul>
  <p>Uwagi końcowe:</p>
  <ul>
    <li>
        Przy stałej pracy przy komputerze należy:
        <ul>
            <li>łączyć przemiennie prace związana z obsługą monitora ekranowego z innymi rodzajami prac nie obciążającymi narządu wzroku i wykonywanymi  w innych pozycjach ciała – przy nieprzekraczaniu 1 godziny nieprzerwanej pracy przy obsłudze monitora ekranowego lub</li>
            <li>co najmniej 5-minutową przerwę, wliczaną do czasu pracy, po każdej godzinie pracy przy obsłudze monitora ekranowego.</li>
        </ul>
    </li>
  </ul>
  <p style="margin-top: 30px;">Oświadczam, iż zapoznałem się i akceptuję powyższa zasady bhp przy pracy administracyjno-biurowej.</p>
  <div style="margin-top: 40px; font-size: 10px;">
    <p style="font-size: 14px; margin-bottom: 0;">{{ imieNazwisko }}</p>
    <p style="font-size: 14px;">Podpis Zleceniobiorcy</p>
  </div>
</div>
  
  </v-container>
</template>

<script>
export default {
  name: 'WzorUmowaNauczycielAngielski2023',
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      zamieszkany: '',
      korespondencyjny: '',
      pesel: '',
      nrRachunku: '',
      nrDowodu: '',
      nrTelefonu: '',
      email: '',
      emeryt: '',
      rencista: '',
      orzeczenieNiepelnosprawnosc: '',
      stopienNiepelnosprawnosc: '',
      student: '',
      jedenyTytulDoUbezpieczenia: '',
      chorobowe: '',
      zatrudnionyUmowaPraca: '',
      nazwaUmowaPraca: '',
      wynagrodzenieUmowaPraca: '',
      ubezpieczenieUmowaPraca: '',
      tytulUbezpieczenieUmowaPraca: '',
      umowaOd: '',
      umowaDo: '',
      urzadSkarbowy: '',
      nrUmowy: '',
      datapocz: '',
      datakon: '',
      kwota: '',
      wypo: '',
      slownie: '',
      kwotapokaz: '',
      slowniepokaz: '',
      shortUmowa: '',
      obywatelstwo: '',
      przedmiot: ''
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
    shortNrUmowy () {
      let tab = []
      let shortPosition = ''
      tab = this.nrUmowy.split('/')
      switch(tab[3]) {
        case 'Nauczyciel':
          shortPosition = 'Naucz'
          break;
        case 'Metodyk':
          shortPosition = 'Met'
          break
        case 'TworcaMaterialow':
          shortPosition = 'TMat'
          break
        case 'TworcaMaterialowNauczycielMetodyk':
          shortPosition = 'TMatNauMet'
          break
        case 'TworzenieProgramuNauczania':
          shortPosition = 'TPNau'
          break
        case 'AsystentOrganizacyjny':
          shortPosition = 'AOrg'
          break
        case 'MłodszyAsystentOrganizacyjny':
          shortPosition = 'MAOrg'
          break
        case 'TworzenieMap':
          shortPosition = 'TMapMC'
          break
        default:
          shortPosition = tab[3]
      }
      const shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/${shortPosition}`
      return shortUmowa
    },
    slownieAngielski() {
      switch(this.kwota) {
        case '25':
          return 'twenty-five'
          break
        case '30':
          return 'thirty'
          break
        case '35':
          return 'thirty-five'
          break
        case '40':
          return 'forty'
          break
        case '45':
          return 'forty-five'
          break
        case '50':
          return 'fifty'
          break
        case '55':
          return 'fifty-five'
          break
        case '60':
          return 'sixty'
          break
        case '65':
          return 'sixty-five'
          break
        case '70':
          return 'seventy'
          break
        case '75':
          return 'seventy-five'
          break
        case '80':
          return 'eighty'
          break
        case '85':
          return 'eighty-five'
          break
        case '90':
          return 'ninety'
          break
        case '95':
          return 'ninety-five'
          break
        default:
          return this.slownie
      }
    },
    slowniePokazAngielski() {
      switch(this.kwotapokaz) {
        case '25':
          return 'twenty-five'
          break
        case '30':
          return 'thirty'
          break
        case '35':
          return 'thirty-five'
          break
        case '40':
          return 'forty'
          break
        case '45':
          return 'forty-five'
          break
        case '50':
          return 'fifty'
          break
        case '55':
          return 'fifty-five'
          break
        case '60':
          return 'sixty'
          break
        case '65':
          return 'sixty-five'
          break
        case '70':
          return 'seventy'
          break
        case '75':
          return 'seventy-five'
          break
        case '80':
          return 'eighty'
          break
        case '85':
          return 'eighty-five'
          break
        case '90':
          return 'ninety'
          break
        case '95':
          return 'ninety-five'
          break
        default:
          return this.slowniepokaz
      }
    },
    dataObowiazywaniaUmowyPolski () {
      if (this.umowaOd === '' || this.umowaOd === '30-12-1899') {
        return 'podpisania umowy'
      } else {
        return `${this.umowaOd} r.`
      }
    },
    dataObowiazywaniaUmowyAngielski () {
      if (this.umowaOd === '' || this.umowaOd === '30-12-1899') {
        return 'the day of its conclusion'
      } else {
        return `${this.umowaOd} r.`
      }
    },
    zamawiajacyAngielski() {
      if (this.zamawiajacy === 'Marcin Grzelak - Prezes Zarządu') {
        return 'Marcin Grzelak - Chairman of the Board'
      } else {
        return this.zamawiajacy
      }
    },
    aktualnaData() {
      const today = new Date();
      let day = today.getDate();
      if((day+1) <= 10) {
        day = '0' + day
      }
      let month = today.getMonth()+1;
      if ((today.getMonth()+1) < 10) {
        month = '0' + month
      } 
      const todayDate = day+'-'+month+'-'+today.getFullYear()
      return todayDate
    }
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href
          history.replaceState(history.state, '', '/')
          window.print()
          history.replaceState(history.state, '', currentURL)
        }, 300)
      })
    }
  }
}
</script>

<style scoped>

.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}

table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}

th, td {
  border: 1px;
  border-collapse: collapse;
}

.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.cointainer-left {
  width: 20%;
}

.right-cointainer {
  text-align: end;
}

thead {
  display: table-header-group;
}

.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}

.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}

ul.dashed {
  list-style-type: "- ";
  margin: 0;
}

.underline {
  text-decoration: underline;
}

.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}

#oswiadczenie {
  padding: 20px;
}

.p-margin {
  margin-bottom: 5px !important;
}

.polish {
  width: 50%;
}

.english {
  width: 50%;
  padding-left: 18px;
}

.attachments {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/WzorUmowaNauczycielAngielski2023.vue